import common from './common'
import featuresPay from './feature'

const gu = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "ઉત્પાદન/વિકલ્પો",
        serialNumber: "સીરીયલ નંબર",
        noProductsFound: "કોઈ ઉત્પાદનો મળ્યાં નથી",
        searchByProductSku: "ઉત્પાદન/SKU દ્વારા શોધો",
        searchSerialNumbers: "સીરીયલ નંબરો શોધો",
        transactionDetails: "વ્યવહારની વિગતો",
        notAvailable: "લાગુ પડતું નથી",
        mainWarehouse: "મુખ્ય વેરહાઉસ"
    },
    new_build_banner: {
        title: 'નવું સંસ્કરણ:',
        is_available: 'હવે ઉપલબ્ધ છે',
        fallback_title: 'એપ્લિકેશનનું નવું સંસ્કરણ ઉપલબ્ધ છે',
        desc: 'નવીનતમ સુવિધાઓ અને સુધારાઓ મેળવવા માટે રિફ્રેશ કરો।',
        refreshing: 'રિફ્રેશ થઈ રહ્યું છે…',
        refresh_now: 'હમણાં રિફ્રેશ કરો',
        later: 'પછીથી',
        you_are_on: "તમે અત્યારે આ પર છો"
    },
    short: {
        finance: 'હિતાશી',
        stock: 'સ્ટોક'
    },
    onboarding: {
        welcome: 'સ્વાગત છે!',
        step: {
            product: {
                totalBreakdown: 'કુલ વિગતો',
                overallFulfilment: 'કુલ પરિપૂર્ણતા',
                totalShippedQty: 'કુલ મોકલેલ જથ્થો',
                totalReceivedQty: 'કુલ પ્રાપ્ત જથ્થો',
                totalOrderedQty: 'કુલ ઓર્ડર કરેલ જથ્થો',
                totalShippedOrdered: 'કુલ મોકલેલ / ઓર્ડર કરેલ',
                totalReceivedOrdered: 'કુલ પ્રાપ્ત / ઓર્ડર કરેલ',
                viewQty: 'જથ્થો જુઓ',
                fetchingQty: 'જથ્થાની વિગતો લાવી રહ્યું છે...',
                noStockInfo: 'કોઈ સ્ટોક માહિતી મળી નથી',
                title: '65% પ્રાપ્ત',
                description: 'તમારી સફળતાના પ્રારંભ માટે ફક્ત 2 પગલાં બાકી છે!',
                    Warehouse: "ગોદામ",
},
            stock: {
                title: '95% લગભગ પૂર્ણ!!',
                description: 'તમારી સફળતાના પ્રારંભ માટે ફક્ત એક વધુ પગલું બાકી છે! તેને હવે પૂર્ણ કરો.'
            }
        },
        business: {
            title: 'વ્યાપાર સફળતાપૂર્વક સર્જાયો!',
            description: 'સુંદર! તમારો વ્યવસાય નોંધાયેલ છે'
        },
        product: {
            title: 'તમારો પહેલો ઉત્પાદન ઉમેરો',
            description: 'સ્ટોક નોંધવા માટે એક ઉત્પાદન ઉમેરો',
                Warehouse: "ગોદામ",
},
        stock: {
            title: 'સ્ટોક ઉમેરવાનો પ્રયાસ કરો',
            description: 'આવતી અને જતા સ્ટોકને નોંધવાનું શરૂ કરો'
        },
        action: {
            add_business: {
                title: 'વ્યાપાર બનાવો',
                description: 'નવો વ્યવસાય બનાવવો છે? અહીં ક્લિક કરો'
            },
            join_business: {
                title: 'વ્યાપારમાં જોડાઓ',
                description: 'શું તમારી પાસે આમંત્રણ કોડ છે? અહીં જોડાઓ'
            }
        }
    },
    business: {
        title: 'એક વ્યવસાય પસંદ કરો, નવો બનાવો અથવા જોડાઓ',
        add_business: {
            title: 'નવો વ્યવસાય બનાવો',
            name: 'વ્યાપારનું નામ',
            name_placeholder: 'નામ દાખલ કરો',
            category: 'વ્યાપાર શ્રેણી',
            category_placeholder: 'શ્રેણી પસંદ કરો',
            button: 'વ્યાપાર બનાવો'
        },
        edit_business: {
            title: 'વ્યાપાર સંપાદિત કરો'
        },
        join_business: {
            title: 'વ્યાપારમાં જોડાઓ',
            input_code: 'નીચે આપેલ આમંત્રણ કોડ દાખલ કરો:',
            field_placeholder: 'આમંત્રણ કોડ',
            confirm_title: 'જોડાઓ',
            confirm_text: 'તમે ત્યાંની ટીમનો ભાગ બનશો '
        },
        no_business: 'કોઈ વ્યવસાય ઉપલબ્ધ નથી',
        create_or_join: 'વ્યાપાર બનાવો અથવા જોડાઓ',
        message: {
            saved: 'વ્યાપાર સફળતાપૂર્વક સાચવ્યો!'
        },
        settings: {
            isNegativeTransactionDisabled: 'નેગેટિવ સ્ટોક ટ્રાન્સેક્શન',
            isNegativeTransactionDisabledHint: 'આને ચાલુ કરવાથી તમે નેગેટિવ સ્ટોકમાં પરિણમતી ટ્રાન્સેક્શન અટકાવી શકો છો.',
            negativeStockError: 'નેગેટિવ સ્ટોક ટ્રાન્સેક્શન અક્ષમ છે'
        }
    },
    profile: {
        edit_profile: {
            title: 'પ્રોફાઇલ સંપાદિત કરો',
            name: 'પૂર્ણ નામ',
            name_placeholder: 'પૂર્ણ નામ દાખલ કરો',
            email: 'ઈમેલ',
            phone_number: 'ફોન નંબર'
        },
        message: {
            required_name: 'નામ આવશ્યક છે'
        }
    },
    product: {
        weightedAverageCost: 'ભારિત સરેરાશ કિંમત',
        weightedAverageValueLabel: 'ભારિત સરેરાશ મૂલ્ય',
        Product: 'ઉત્પાદન',
        hideZeroStock: 'શૂન્ય સ્ટોક છુપાવો',
        allVariants: 'બધા વેરિઅન્ટ્સ',
        choose_product: 'ઉત્પાદન પસંદ કરો',
        choose_product_empty: 'ઉત્પાદન પસંદ કરો અને માત્રા દાખલ કરો',
        search: {
            placeholder: 'નામ દ્વારા શોધો',
            tooltip: 'સ્કેનર ખોલો',
                Warehouse: "ગોદામ",
},
        column: {
            invoice: "ઇન્વોઇસ",
            image: 'ફોટો',
            name: 'નામ',
            price: 'કિંમત',
            buying_price: 'ખરીદી કિંમત',
            selling_price: 'વેચાણ કિંમત',
            sku: 'SKU',
            stock: 'સ્ટોક',
            quantity: 'જથ્થો',
            latest_stock: 'બાકી',
            product_deleted: 'ઉત્પાદન દૂર કરાયું છે',
            info_not_found: 'માહિતી ઉપલબ્ધ નથી',
            expired_date: 'સમાપ્તિ તારીખ'
        },
        no_product: 'કોઈ ઉત્પાદન ઉપલબ્ધ નથી',
        no_product_subtitle: 'સ્ટોક, કિંમત અને વેચાણ ટ્રેક કરવાનું શરૂ કરવા માટે તમારું પ્રથમ ઉત્પાદન ઉમેરો.',
        create_first_product: 'તમારું પ્રથમ ઉત્પાદન બનાવો',
        add_product: {
            sku: 'ઉત્પાદન કોડ',
            sku_placeholder: 'ઉત્પાદન કોડ. ઉદાહરણ: 12345',
            name: 'ઉત્પાદન નામ',
            name_placeholder: 'ઉત્પાદન નામ દાખલ કરો',
            initial_stock: 'પ્રારંભિક સ્ટોક',
            initial_stock_placeholder: 'પ્રારંભિક સ્ટોક દાખલ કરો',
            buying_price: 'ખરીદી કિંમત',
            buying_price_placeholder: 'ખરીદી કિંમત દાખલ કરો',
            selling_price: 'વેચાણ કિંમત',
            selling_price_placeholder: 'વેચાણ કિંમત દાખલ કરો',
            category: 'શ્રેણી',
            category_placeholder: 'શ્રેણી પસંદ કરો',
            add_selling_price: 'થોક કિંમત ઉમેરો',
            expired_date: 'સમાપ્તિ તારીખ',
            expired_date_placeholder: 'તારીખ પસંદ કરો',
            description: 'વર્ણન',
            description_placeholder: 'વર્ણન દાખલ કરો',
                Warehouse: "ગોદામ",
},
        choose_selling_price: 'વેચાણ કિંમત પસંદ કરો',
        selling_price: 'વેચાણ કિંમત',
        total_product: 'કુલ ઉત્પાદનો',
        total_quantity: 'કુલ સ્ટોક',
        total_buying_price: 'કુલ ખરીદી કિંમત',
        total_selling_price: 'કુલ વેચાણ કિંમત',
        message: {
            required_name: 'ઉત્પાદન નામ આવશ્યક છે',
            required_sku: 'SKU આવશ્યક છે',
            required_category: 'શ્રેણી આવશ્યક છે',
            required_quantity: 'પ્રારંભિક સ્ટોક આવશ્યક છે',
            invalid_input_qty: 'અમાન્ય સ્ટોક જથ્થો',
            required_buying_price: 'ખરીદી કિંમત આવશ્યક છે',
            required_selling_price: 'વેચાણ કિંમત આવશ્યક છે',
            required_selling_price_name: 'વેચાણ કિંમત નામ આવશ્યક છે',
            required_selling_price_price: 'વેચાણ કિંમત આવશ્યક છે'
        },
        viewMore: 'વધુ જુઓ',
        WarehouseDetails: 'ગોડાઉન વિગતો',
        WarehouseName: 'ગોડાઉનનું નામ',
        AddWarehouse: 'ગોડાઉન ઉમેરો',
        WarehouseQty: 'ગોડાઉન જથ્થો',
        Warehouse: 'ગોડાઉન',
        Warehouses: 'ગોડાઉન',
        Variants: 'પ્રકાર',
        VariantName: 'પ્રકારનું નામ',
        productVariant: 'ઉત્પાદન પ્રકાર',
        AddVariant: 'પ્રકાર ઉમેરો',
        TranferItem: 'વસ્તુઓ હસ્તાંતર કરો',
        AddUnit: 'નવી એકમ',
        InitialStkWarehouse: 'પ્રકાર ઉમેરવા માટે પ્રારંભિક જથ્થો જરૂરી છે',
        InitialStockinwarehouse: 'ગોડાઉનમાં પ્રારંભિક જથ્થો',
        TotalQuantity: 'કુલ જથ્થો:',
        AddNote: 'નોંધ ઉમેરો (કિંમત)',
        AddNotetitle: 'નોંધ ઉમેરો',
        VariantSuccessMessage: 'ઉત્પાદન પ્રકાર સફળતાપૂર્વક અપડેટ થયો',
        Next: 'આગળ',
        Submit: 'સબમિટ',
        INACTIVE: 'નિષ્ક્રિય',
        errorone: 'અફસોસ! વિનંતી કરેલો જથ્થો',
        errortwo: 'સોંપાયેલા ગોડાઉન જથ્થા સાથે મેળ ખાતો નથી. કૃપા કરીને જથ્થો સમાયોજિત કરો અથવા સ્ટોક ફરીથી ભરવો.',
        SelectWarehouse: 'ગોડાઉન પસંદ કરો',
        SelectVariant: 'વેરિઅન્ટ પસંદ કરો',
        Discount: 'ડિસ્કાઉન્ટ',
        DiscountDetails: 'ડિસ્કાઉન્ટ વિગતો',
        FinalPrice: 'અંતિમ કિંમત',
        DiscountType: 'ડિસ્કાઉન્ટ પ્રકાર',
        DiscountPer: 'ડિસ્કાઉન્ટ %',
        DiscountValue: 'ડિસ્કાઉન્ટ મૂલ્ય',
        Discountonprice: 'કિંમત પર ડિસ્કાઉન્ટ',
        Discountondiscount: 'ડિસ્કાઉન્ટ પર ડિસ્કાઉન્ટ',
        AdditionalDiscount: 'વધારાનો ડિસ્કાઉન્ટ',
        SellingPrice: 'વેચાણ કિંમત:',
        Save: 'સંગ્રહ કરો',
        OnOriginalPrice: 'મૂળ કિંમતે',
        OnDiscountedPrice: 'છૂટછાટ કિંમતે',
        columnSelector: {
            title: 'કૉલમ બતાવો',
            columnsButton: 'કૉલમ',
            costPrice: 'ખરીદ કિંમત',
            sellingPrice: 'વેચાણ કિંમત',
            sku: 'SKU',
            warehouse: 'ગોદામ',
            categories: 'શ્રેણીઓ',
            safetyStock: 'સુરક્ષા સ્ટોક',
            attributes: 'વિશેષતાઓ',
            notes: 'નોંધો',
            description: 'વર્ણન',
            more: 'વધુ',
            attribute: 'વિશેષતા',
            attributesTitle: 'વિશેષતાઓ',
            categoriesTitle: 'શ્રેણીઓ',
            skuAliases: 'SKU ઉપનામો'
        }
    },
    note: {
        title: 'નોટ્સ',
        add: 'નોટ ઉમેરો',
        no_note: 'કોઈ નોટ્સ ઉપલબ્ધ નથી'
    },
    settings: {
        category: 'શ્રેણી',
        language: 'ભાષા',
        switch_business: 'બિઝનેસ બદલો',
        currencySelect: 'મુદ્રા',
        languageChangeSuccess: "કરન્સી સફળતાપૂર્વક અપડેટ થઈ ગઈ",
        languageChangeErrorMessage: "કરન્સી અપડેટ કરતી વખતે કંઈક ખોટું થયું",
        currencyAdded: "કરન્સી સફળતાપૂર્વક ઉમેરાઈ ગઈ",
        currencyDelete: "કરન્સી સફળતાપૂર્વક કાઢી નાખવામાં આવી",
        Selectyourpreferredlanguage: "તમારી પસંદગીની ભાષા પસંદ કરો",
    },
    category: {
        category_list: {
            title: 'ઉત્પાદન શ્રેણીઓ'
        },
        add_category: {
            button: 'નવી શ્રેણી',
            title: 'નવી શ્રેણી ઉમેરો'
        },
        edit_category: {
            title: 'શ્રેણી સંપાદિત કરો'
        },
        name: 'શ્રેણીનું નામ',
        name_placeholder: 'શ્રેણીનું નામ દાખલ કરો',
        no_category: 'કોઈ શ્રેણીઓ ઉપલબ્ધ નથી'
    },
    staff: {
        add: 'સ્ટાફ ઉમેરો',
        edit: 'સ્ટાફ સંપાદિત કરો',
        access: {
            stock: 'સ્ટોક',
            add_product: 'નવી ઉત્પાદન ઉમેરો',
            edit_product: 'ઉત્પાદન સંપાદિત કરો',
            delete_product: 'ઉત્પાદન કાઢી નાખો',
            view_capital_price: 'ખર્ચ કિંમત જુઓ',
            add_category: 'નવી શ્રેણી ઉમેરો',
            edit_category: 'શ્રેણી સંપાદિત કરો',
            delete_category: 'શ્રેણી કાઢી નાખો',
            add_supplier: 'નવી પુરવઠા ઉમેરો',
            edit_supplier: 'પુરવઠા સંપાદિત કરો',
            delete_supplier: 'પુરવઠા કાઢી નાખો',
            add_customer: 'નવી ગ્રાહક ઉમેરો',
            edit_customer: 'ગ્રાહક સંપાદિત કરો',
            delete_customer: 'ગ્રાહક કાઢી નાખો',
            add_staff: 'સ્ટાફ ઉમેરો',
            edit_staff: 'સ્ટાફ સંપાદિત કરો',
            delete_staff: 'સ્ટાફ કાઢી નાખો',
            change_business_profile: 'બિઝનેસ પ્રોફાઇલ બદલો',
            access_by_product_category: 'ઉત્પાદન શ્રેણી દ્વારા ઍક્સેસ',
            no_category_message: 'તમારી પાસે કોઈ શ્રેણી ઉમેરેલ નથી. કૃપા કરીને એક શ્રેણી ઉમેરો.',
            expenses: 'ખર્ચ',
            view_expenses: 'ખર્ચ જુઓ',
            add_expenses: 'ખર્ચ ઉમેરો',
            edit_expenses: 'ખર્ચ સંપાદિત કરો',
            delete_expenses: 'ખર્ચ હટાવો',
            warehouse: 'ગોડાઉન',
            add_new_warehouse: 'નવું ગોડાઉન ઉમેરો',
            edit_warehouse: 'ગોડાઉન સંપાદિત કરો',
            delete_warehouse: 'ગોડાઉન હટાવો',
            transfer_warehouse: 'ગોડાઉન સ્થાનાંતરિત કરો',
            transfer_warehouse_approval: 'ગોડાઉન સ્થાનાંતરણ મંજૂરી',
            access_by_warehouse: 'વેરહાઉસ દ્વારા ઍક્સેસ',
            no_warehouse_message: 'તમારું કોઈ વેરહાઉસ ઉમેરેલ નથી. કૃપા કરીને વેરહાઉસ સૂચિ ઉમેરો.',
            purchase_order: "ખરીદી ઓર્ડર",
            purchase_order_creation: "ખરીદી ઓર્ડર બનાવવું",
            purchase_order_edit: "ખરીદી ઓર્ડર સંપાદન",
            purchase_order_cancel: "ખરીદી ઓર્ડર રદ",
            purchase_order_reopen: "ખરીદી ઓર્ડર ફરીથી ખોલો",
            purchase_order_receive: "ખરીદી ઓર્ડર પ્રાપ્ત",
            sales_order: "વેચાણ ઓર્ડર",
            sales_order_creation: "વેચાણ ઓર્ડર બનાવવું",
            sales_order_edit: "વેચાણ ઓર્ડર સંપાદન",
            sales_order_cancel: "વેચાણ ઓર્ડર રદ",
            sales_order_reopen: "વેચાણ ઓર્ડર ફરીથી ખોલો",
            sales_order_receive: "વેચાણ ઓર્ડર મોકલાયો",
            purchase_order_approval: "ખરીદી ઓર્ડર મંજૂરી",
            sales_order_approval: "વેચાણ ઓર્ડર મંજૂરી",
            can_do_available_warehouse: "ઉપલબ્ધ વેરહાઉસ",
            add_batch: "બેચ બનાવવાની મંજૂરી"
            ,
            notification: 'સૂચના',
            staffNotification: 'સૂચના સક્ષમ કરો',
        assignee: "સોંપેલ વ્યક્તિ",
    },
        no_staff: 'કોઈ સ્ટાફ ઉપલબ્ધ નથી.'
    },
    code: {
        title: 'નવી સ્ટાફ ઉમેરાયેલ!',
        subtitle: 'જોડાવા માટે નીચેનો આમંત્રણ કોડ શેર કરો:',
        valid: 'કોડ 48 કલાક માટે જ માન્ય છે',
        share: 'વોટ્સએપ પર શેર કરો',
        copied: 'કોપી કરેલ!',
        invalid: 'અમાન્ય કોડ!'
    },
    history: {
        no_history: 'કોઈ ઇતિહાસ નથી.',
        detail: {
            remove: 'ઇતિહાસ દૂર કરો',
            confirm: 'આ કાર્યમાં જતેલા સ્ટોક, ઇતિહાસ અને અહેવાલો પર અસર કરશે.'
        },
        no_history_selected: "કોઈ ઇતિહાસ પસંદ કરવામાં આવ્યો નથી",
        select_history_hint: "વિગતો જોવા માટે યાદીમાંથી કોઈ ઇતિહાસ પર ક્લિક કરો",
        select_from_left: "ડાબી બાજુના પેનલમાંથી પસંદ કરો",
    },
    supplier: {
        add: {
            title: 'વેંડર ઉમેરો'
        },
        edit: {
            title: 'વેંડર સંપાદિત કરો'
        },
        new: 'નવો વેંડર',
        no_supplier: 'કોઈ વેંડર્સ ઉપલબ્ધ નથી.',
        bank: {
            title: 'બેંક વિગતો'
        },
        note: 'નોટ્સ',
        form: {
            name: {
                label: 'વેંડર નામ',
                placeholder: 'વેંડર નામ દાખલ કરો',
                placheolder_not_mandatory: 'નામ દાખલ કરો (વૈકલ્પિક)',
                error: {
                    required: 'નામ ખાલી નથી હોઈ શકે'
                }
            },
            contact: {
                label: 'સંપર્ક નંબર',
                placeholder: '91934554432',
                error: {
                    required: 'સંપર્ક નંબર ખાલી નથી હોઈ શકે',
                    invalid: 'ખોટો નંબર. દેશ કોડ સમાવેશ કરવો અનિવાર્ય છે'
                }
            },
            bank_name: {
                label: 'બેંક નામ',
                placeholder: 'બેંક નામ દાખલ કરો'
            },
            bank_account_name: {
                label: 'ખાતાધારકનું નામ',
                placeholder: 'ખાતાધારકનું નામ દાખલ કરો'
            },
            bank_account_number: {
                label: 'ખાતાનો નંબર',
                placeholder: 'ખાતાનો નંબર દાખલ કરો'
            },
            note: {
                label: ' નોંધો',
                placeholder: 'નોંધો ઉમેરો'
            },
            openingBalance: {
                addBtn: 'પ્રારંભિક સિલક ઉમેરો',
                label: 'પ્રարંભિક સિલક (Opening Balance)',
                placeholder: 'પ્રારંભિક સિલક દાખલ કરો',
                error: {
                    negative: 'પ્રારંભિક સિલક નકારાત્મક હોઈ શકે નહીં'
                }
            }
        },
        choose: 'વેંડર પસંદ કરો'
    },
    customer: {
        add: {
            title: 'ગ્રાહક ઉમેરો'
        },
        edit: {
            title: 'ગ્રાહક સંપાદિત કરો'
        },
        new: 'નવો ગ્રાહક',
        no_customer: 'કોઈ ગ્રાહક ઉપલબ્ધ નથી.',
        note: 'નોંધો',
        form: {
            name: {
                label: 'ગ્રાહકનું નામ',
                placeholder: 'ગ્રાહકનું નામ દાખલ કરો',
                placheolder_not_mandatory: 'નામ દાખલ કરો (ઓપ્શનલ)',
                error: {
                    required: 'નામ ખાલી નથી હોઈ શકે'
                }
            },
            contact: {
                label: 'સંપર્ક નંબર',
                placeholder: '91934554432',
                error: {
                    required: 'સંપર્ક નંબર ખાલી નથી હોઈ શકે',
                    invalid: 'અમાન્ય નંબર. દેશમાં કોડ સમાવેશ થવો જોઈએ'
                }
            },
            address: {
                label: 'સરનામું',
                placeholder: 'સરનામું દાખલ કરો'
            },
            note: {
                label: 'નોંધો',
                placeholder: 'નોંધો ઉમેરો'
            },
            openingBalance: {
                addBtn: 'પ્રારંભિક સિલક ઉમેરો',
                label: 'પ્રարંભિક સિલક (Opening Balance)',
                placeholder: 'પ્રારંભિક સિલક દાખલ કરો',
                error: {
                    negative: 'પ્રારંભિક સિલક નકારાત્મક હોઈ શકે નહીં'
                }
            }
        },
        choose: 'ખરેદક પસંદ કરો',
        report: {
            view: 'ખરેદક રિપોર્ટ જુઓ',
            title: 'ખરેદક રિપોર્ટ',
            no_report: 'આ પસંદ કરેલ તારીખે કૃણાકો માટે કોઈ રિપોર્ટ નથી.',
            column: {
                name: 'નામ',
                total_transaction: 'કુલ વ્યવહારો',
                total_amount: 'કુલ વેચાણ',
                total_profit: 'કુલ નફો'
            }
        }
    },
    confirm_delete: 'શું તમે ખરેખર આ માહિતી કાઢી નાખવા માંગો છો?',
    report: {
        title: 'રિપોર્ટ'
    },
    accounting: {
        download_pdf_report: 'PDF ડાઉનલોડ કરો',
        title: 'હિસાબકી',
        view_report: 'વિત્તીય રિપોર્ટ જુઓ',
        dashboard_title: 'વિત્તીય રિપોર્ટ',
        stats: 'આંકડા',
        accounting_report: 'હિસાબકી રિપોર્ટ',
        filter: {
            date: {
                placeholder: 'તારીખ પસંદ કરો',
                submit: 'લાગુ કરો',
                cancel: 'ફિલ્ટર ફરી જાળવો'
            },
            timeframe: {
                day: 'દિવસે',
                week: 'સાપ્તાહિક',
                month: 'માસિક',
                year: 'વાર્ષિક'
            }
        },
        total_sales: 'કુલ વેચાણ',
        total_purchases: 'કુલ ખરીદી',
        total_profit: 'કુલ નફો',
        total_expenses: 'કુલ ખર્ચ',
        assets_value: 'વર્તમાન સંપત્તિ મૂલ્ય',
        total_current_cogs_value: 'કુલ વર્તમાન COGS મૂલ્ય',
        current_asset_selling_price: 'વર્તમાન સંપત્તિ વેચાણ કિંમત',
        total_selling_price: 'કુલ વેચાણ કિંમત',
        table: {
            date: 'તારીખ',
            sales: 'વેચાણ',
            purchases: 'ખરીદીઓ',
            profit: 'નફો',
            expenses: 'ખર્ચ'
        },
        no_data: 'કોઈ ડેટા ઉપલબ્ધ નથી.'
    },
    stock_report: {
        title: 'સ્ટોક રિપોર્ટ',
        view: 'સ્ટોક રિપોર્ટ જુઓ',
        no_report: 'ચણેલી તારીખ અથવા સ્ટાફ માટે કોઈ સ્ટોક રેકોર્ડ નથી.',
        allStaffPlaceHolder: 'બધા સ્ટાફ',
        column: {
            total_product: 'વર્તમાન ઉત્પાદન પ્રકારો',
            total_product_quantity: 'કુલ વર્તમાન ઉત્પાદનો'
        }
    },
    subscription: {
        paywall_small: {
            title: 'વીઆઇપી સુવિધા',
            description:
                'આ સુવિધાનો તમારો ટ્રાયલ સમય સમાપ્ત થયો છે. સબ્સ્ક્રાઇબ કરીને આ સ્થાનિક એપ્લિકેશનના વિકાસને સમર્થન આપો.',
            button: 'સબ્સ્ક્રિપ્શન યોજનાઓ જુઓ'
        }
    },
    payment: {
        order: {
            title: 'ચૂકવણી'
        }
    },
    imageUploadMessage: {
        uploadSize: 'છબીનું કદ 5MBથી વધુ ન હોવું જોઈએ!',
        failedMessage: 'ઉત્પાદન છબી અપલોડ કરવામાં નિષ્ફળ, કૃપા કરીને ફરી પ્રયાસ કરો!',
        successUpload: 'છબી સફળતાપૂર્વક અપલોડ થઈ ગઈ!',
        failedUIError: 'છબી કાઢવામાં નિષ્ફળ, કૃપા કરીને ફરી પ્રયાસ કરો!',
        SuccessErrorImage: 'છબી સફળતાપૂર્વક કાઢી નાખવામાં આવી!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'ઉત્પાદન નામ',
        categoryLabel: 'શ્રેણી',
        BuyingPriceLabel: 'ખરીદ કિંમત',
        SellingLabel: 'વેચાણ કિંમત',
        StockLabel: 'સ્ટોક'
    },
    historyColumns: {
        Transactionlabel: 'ટ્રાન્ઝેક્શન પ્રકાર',
        Locallabel: 'સ્થાનીક સમય',
        Createdlabel: 'બનાવ્યો',
        Vendorlabel: 'વિક્રેતા નામ',
        Buyerlabel: 'ખરીદદાર નામ',
        SKUlabel: 'SKU',
        Productlabel: 'ઉત્પાદન નામ',
        Categorylabel: 'શ્રેણી',
        Buyinglabel: 'ખરીદ કિંમત',
        Sellinglabel: 'વેચાણ કિંમત',
        Initiallabel: 'પ્રારંભિક સ્ટોક',
        Finallabel: 'અંતિમ સ્ટોક',
        Stocklabel: 'સ્ટોકમાં ફેરફાર'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'ઉત્પાદન નામ',
        categoryLabel: 'શ્રેણી',
        buyingPriceLabel: 'ખરીદ કિંમત',
        sellingPriceLabel: 'વેચાણ કિંમત',
        stockInLabel: 'સ્ટોકમાં',
        stockOutLabel: 'સ્ટોક બહાર',
        remainingStockLabel: 'બાકી રહેલો સ્ટોક',
        weightedAverageCost: 'ભારિત સરેરાશ કિંમત',
        weightedAverageCostLabel: 'ભારિત સરેરાશ કિંમત',
        weightedAverageValueLabel: 'ભારિત સરેરાશ મૂલ્ય'
    },
    accountingReportColumns: {
        dateRange: 'તારીખની શ્રેણી',
        reportingPeriod: 'રિપોર્ટિંગ સમયગાળો',
        reportGenerate: 'રિપોર્ટ જનરેટ',
        warehouse: 'વેરહાઉસ',
        labelDate: 'તારીખ',
        labelSales: 'બેચ',
        labelPurchases: 'ખરીદીઓ',
        labelProfit: 'મુખ્ય નફો',
        labelExpenses: 'ખર્ચ',
        reportOptions: 'અહેવાલ કૉલમ્સ',
        summaryCards: 'સારાંશ કાર્ડ્સ',
        grandTotal: 'કુલ સરવાળો',
        continued: 'ચાલુ',
        subtotal: 'પેટા-કુલ',
        page: 'પૃષ્ઠ'
    },
    customerReportColumns: {
        labelName: 'નામ',
        labelTotalTransaction: 'કુલ ટ્રાન્ઝેક્શન',
        labelTotalSales: 'કુલ વેચાણ',
        labelTotalProfit: 'કુલ નફો'
    },
    scannerDialog: {
        finished: 'પૂર્ણ',
        reduce: 'કમાવો',
        successfull: 'સફળ',
        searching: 'શોધી રહ્યું છે...',
        title: 'સ્કેનર સક્રિય. બારકોડ તરફ તાળે કરો!'
    },
    historyFilter: {
        SelectBuyer: 'ખરીદનાર પસંદ કરો',
        SelectVendor: 'વિક્રેતા પસંદ કરો'
    },
    productStockFilter: {
        StockLowtoHigh: 'સ્ટોક ઓછા થી વધુ',
        StockHightoLow: 'સ્ટોક વધુ થી ઓછા',
        AlphabetAZ: 'અક્ષર A-Z',
        AlphabetZA: 'અક્ષર Z-A'
    },
    minimizeTitle: 'સ્કેનર સક્રિય',
    security_guarantee: {
        title: 'માહિતી સુરક્ષા ગેરન્ટી'
    },
    invoice: {
        invoicePlaceholder: 'ચાલાન નંબર',
        invoiceTitle: 'ચાલાન',
        manageInvoiceAddress: 'ઇન્વૉઇસ સરનામું મેનેજ કરો',
        selectOrManageAddresses: 'કસ્ટમ ઇન્વૉઇસ સરનામાં પસંદ કરો, સંપાદિત કરો અથવા બનાવો',
        useBusinessProfileAddress: 'વ્યવસાય પ્રોફાઇલ સરનામું ઉપયોગ કરો',
        noCustomAddressesFound: 'કોઈ કસ્ટમ સરનામાં ઉમેરવામાં આવ્યા નથી',
        createCustomAddressDesc: 'ડિફૉલ્ટ વ્યવસાય પ્રોફાઇલ ડેટાને બદલે તમારા ઇન્વૉઇસ પર છાપવા માટે કસ્ટમ બિલિંગ અથવા શાખા સરનામાં ઉમેરો.',
        defaultFromBusinessProfile: 'વ્યવસાય પ્રોફાઇલ થી ડિફૉલ્ટ',
        editInvoiceAddress: 'ઇન્વૉઇસ સરનામું સંપાદિત કરો',
        createNewInvoiceAddress: 'નવું ઇન્વૉઇસ સરનામું બનાવો',
        logoHeaderImage: 'લોગો / હેડર ઇમેજ',
        deleteInvoiceAddress: 'ઇન્વૉઇસ સરનામું ડિલીટ કરો?',
        deleteAddressConfirmText: 'શું તમે ખરેખર આ ઇન્વૉઇસ સરનામું ડિલીટ કરવા માંગો છો? આ ક્રિયા પૂર્વવત્ કરી શકાતી નથી.'
    },
    ManageInvoiceAddress: 'ઇન્વૉઇસ સરનામું મેનેજ કરો',
    SelectOrManageAddresses: 'કસ્ટમ ઇન્વૉઇસ સરનામાં પસંદ કરો, સંપાદિત કરો અથવા બનાવો',
    UseBusinessProfileAddress: 'વ્યવસાય પ્રોફાઇલ સરનામું ઉપયોગ કરો',
    CreateNewAddress: 'નવું સરનામું બનાવો',
    UpdatingList: 'સૂચિ અપડેટ થઈ રહી છે...',
    NoCustomAddressesFound: 'કોઈ કસ્ટમ સરનામાં ઉમેરવામાં આવ્યા નથી',
    CreateCustomAddressDesc: 'ડિફૉલ્ટ વ્યવસાય પ્રોફાઇલ ડેટાને બદલે તમારા ઇન્વૉઇસ પર છાપવા માટે કસ્ટમ બિલિંગ અથવા શાખા સરનામાં ઉમેરો.',
    DefaultFromBusinessProfile: 'વ્યવસાય પ્રોફાઇલ થી ડિફૉલ્ટ',
    EditInvoiceAddress: 'ઇન્વૉઇસ સરનામું સંપાદિત કરો',
    CreateNewInvoiceAddress: 'નવું ઇન્વૉઇસ સરનામું બનાવો',
    LogoHeaderImage: 'લોગો / હેડર ઇમેજ',
    UploadingImage: 'ઇમેજ અપલોડ થઈ રહી છે...',
    UploadImage: 'ઇમેજ અપલોડ કરો',
    BusinessName: 'વ્યવસાયનું નામ',
    AddressDetails: 'સરનામાની વિગતો',
    PhoneNumber: 'ફોન નંબર',
    EmailAddress: 'ઈ-મેઇલ સરનામું',
    DeleteInvoiceAddress: 'ઇન્વૉઇસ સરનામું ડિલીટ કરો?',
    DeleteAddressConfirmText: 'શું તમે ખરેખર આ ઇન્વૉઇસ સરનામું ડિલીટ કરવા માંગો છો? આ ક્રિયા પૂર્વવત્ કરી શકાતી નથી.',

    stocklowreport: {
        no_stocklowreport_one: 'સુરક્ષા સ્ટોક સેટિંગ્સ સાથે કોઈ આઇટમ્સ નથી.',
        no_stocklowreport_two: 'કૃપા કરીને સુરક્ષા સ્ટોકની માત્રા ઉમેરો.'
    },
    low_alert_stock: 'સુરક્ષા સ્ટોકની માત્રા દાખલ કરો',
    lowStockAlertNotify: 'જ્યારે સ્ટોક નક્કી કરેલી માત્રાથી ઓછો થશે, ત્યારે તમને સૂચના મળશે.',
    applyButtonStockAlert: 'લાગુ કરો',
    cancelButtonStockAlert: 'રદ કરો',
    searchProductLabel: 'પ્રોડક્ટ શોધો...',
    successfullyAddedSafetyStock: 'સુરક્ષા સ્ટોક સફળતાપૂર્વક અપડેટ થયો',
    safety_Stock: 'સુરક્ષા સ્ટોક',
    safety_stock_placeholder: 'સુરક્ષા સ્ટોક દાખલ કરો',
    lowStockDetailsInfo: {
        ProductCode: 'ઉત્પાદન કોડ',
        SafetyStock: 'સુરક્ષા સ્ટોક',
        Stock: 'સ્ટોક',
        CostPrice: 'લागत કિંમત',
        SellingPrice: 'વેચાણ કિંમત',
        Category: 'શ્રેણી',
        Description: 'વર્ણન',
        ExpirationDate: 'સમાપ્તિ તારીખ'
    },
    CustomLang: {
        Attribute: 'ગુણ',
        AddAttribute: 'ગુણ ઉમેરો',
        EditAttribute: 'ગુણ સંપાદિત કરો',
        CustomLabePlaceholder: 'ગુણનું નામ દાખલ કરો',
        CustomLabePlaceholderSelect: 'પ્રકાર પસંદ કરો',
        AddMoreAttribute: 'આરું વધુ ગુણ ઉમેરો',
        ItemAttribute: 'વસ્તુનું ગુણ',
        TableName: 'નામ',
        TableType: 'પ્રકાર',
        TableAction: 'ક્રિયા',
        TableDelete: 'મૂકો',
        TableEdit: 'સંપાદિત કરો',
        deleteMessage: 'ગુણ સફળતાપૂર્વક માવઠાયું',
        editSuccessMessage: 'ગુણ સફળતાપૂર્વક અપડેટ કરવામાં આવ્યો',
        AddSuccessMessage: 'ગુણ સફળતાપૂર્વક ઉમેરવામાં આવ્યો',
        AddAtt: 'ઉમેરો',
        EditAtt: 'સંપાદિત કરો',
        SubmitAtt: 'પાઠવતી રહી છે...'
    },
    Expenses: {
        ExpensesTitle: 'ખર્ચ',
        AddExpenses: 'ખર્ચ ઉમેરો',
        ExpenseCategory: 'ખર્ચની શ્રેણી',
        NoExpenseCategory: 'કોઈ ખર્ચ શ્રેણી નથી',
        AddExpenseCategory: 'ખર્ચની શ્રેણી ઉમેરો',
        SelectExpenseCategory: 'ખર્ચની શ્રેણી પસંદ કરો',
        NoExpenses: 'કોઈ ખર્ચ નથી',
        ExpensesSuccess: 'ખર્ચ સફળતાપૂર્વક બનાવાયો',
        ExpensesSuccessEdit: 'ખર્ચ સફળતાપૂર્વક અપડેટ થયો',
        ExpensesCategoryName: 'ખર્ચ શ્રેણીનું નામ',
        ExpensesSuccessDelete: 'ખર્ચ સફળતાપૂર્વક કાઢી નાખ્યો',
        TotalSpentThisWeek: 'આ અઠવાડિયે કુલ ખર્ચ',
        AddNEC: "નવી ખર્ચ શ્રેણી ઉમેરો",
        NC: "નવી ખર્ચ શ્રેણી",
        EditNEC: "ખર્ચ શ્રેણી સંપાદિત કરો"
    },
    Manufacturing: {
        ProducedProduct: "ઉત્પાદિત વસ્તુ",
        QuantityManufactured: "ઉત્પાદિત જથ્થો",
        UnitCost: "એકમ દીઠ કિંમત",
        RawMaterialsTotal: "કુલ કાચો માલ ખર્ચ",
        TotalManufacturingCost: "કુલ ઉત્પાદન ખર્ચ",
        NoRawMaterialsConsumed: "કોઈ કાચો માલ વપરાયો નથી.",
        CostBreakdown: "ખર્ચ વિગતો",
        GeneratedBatch: "ઉત્પાદિત બેચ",
        StoredBinLocation: "સંગ્રહિત સ્થાન",
        NoManufacturingTransactionsFound: "કોઈ ઉત્પાદન વ્યવહારો મળ્યા નથી",
        AddManufacture: 'ઉત્પાદન વિગતો ઉમેરો',
        Manufacturing: 'ઉત્પાદન',
        RawMaterials: 'કાચો માલ',
        AdditonCosts: 'વધારાની કિંમત',
        RawMaterial: 'કાચો માલ',
        AdditonCost: 'વધારાની કિંમત',
        TotalCost: 'કુલ ખર્ચ',
        AddRawMaterial: 'માટે કાચો માલ ઉમેરો',
        AddAdditonCost: 'માટે વધારાની કિંમત ઉમેરો',
        AddMore: 'વધુ ઉમેરો',
        Add: 'ઉમેરો',
        Update: 'અપડેટ કરો',
        Updating: 'સબમિટ કરી રહ્યું છે...',
        ProductRequired: 'ઉત્પાદન જરૂરી છે',
        QuantityRequired: 'જથ્થો જરૂરી છે',
        ChargeRequired: 'ચાર્જ જરૂરી છે',
        EstimatedCostRequired: 'અંદાજિત ખર્ચ જરૂરી છે',
        PurchasePriceRequired: 'ખરીદી કિંમત જરૂરી છે',
        SelectCharge: 'ચાર્જ પસંદ કરો',
        EstimatedCost: 'અંદાજિત ખર્ચ',
        SelectProduct: 'ઉત્પાદન પસંદ કરો',
        Quantity: 'જથ્થો',
        ManufactureDetails: 'ઉત્પાદન વિગતો',
        BuyingPrice: 'ખરીદી કિંમત',
        LabourCharge: 'મજૂરી ચાર્જ',
        ElectricityCost: 'વિદ્યુત ખર્ચ',
        PackagingCharge: 'પેકેજિંગ ચાર્જ',
        LogisticCost: 'લોજિસ્ટિક ખર્ચ',
        OtherCharges: 'અન્ય ચાર્જ',
        Save: 'વિગતો સાચવો',
        PurchasePrice: 'ખરીદી કિંમત',
        Date: 'તારીખ',
        For: 'માટે',
        PurchaseRate: 'ખરીદી દર (કિંમત)',
        Scrolltoloadmore: 'વધુ લોડ કરવા માટે સ્ક્રોલ કરો...',
        Noproductsfound: 'કોઈ ઉત્પાદન મળ્યું નથી',
        ManufacturingQuantity: 'ઉત્પાદન જથ્થો',
        ManufactureAddedSuccess: 'ઉત્પાદન વિગતો સફળતાપૂર્વક અપડેટ થઈ'
    },
    Warehouses: {
        transferOrder: 'આઈટમ ટ્રાન્સફર કરો',
        AddTransferOrder: 'ટ્રાન્સફર આઈટમ્સ ઉમેરો',
        NewWarehouse: 'નવું વેરહાઉસ',
        newHead: 'મલ્ટીપલ વેરહાઉસ મેનેજ કરવા શરૂ કરો!',
        headTwo: 'તમારા સ્ટોકનું મલ્ટીપલ વેરહાઉસમાં સરળતાથી સંચાલન કરો અને ટ્રેક કરો',
        EnableWarehouse: 'વેરહાઉસ સક્ષમ કરો',
        EnableWarehouse2: 'વેરહાઉસ સક્રિય કરો',
        OrganizationPrimary: 'સંસ્થાનું મુખ્ય વેરહાઉસ',
        Edit: 'સંપાદિત કરો',
        AreEnableWarehouse: 'શું તમે ખરેખર વેરહાઉસ સક્રિય કરવા માંગો છો?',
        Confirm: 'પુષ્ટિ કરો',
        Cancel: 'રદ કરો',
        WarehouseCreatedSuccessfully: 'વેરહાઉસ સફળતાપૂર્વક બનાવાયું',
        MarkAsOP: 'સંસ્થાનું મુખ્ય વેરહાઉસ તરીકે ચિહ્નિત કરો',
        MarkAsInAct: 'નિષ્ક્રિય તરીકે ચિહ્નિત કરો',
        MarkAsAct: 'સક્રિય તરીકે ચિહ્નિત કરો',
        MarkedAsInactive: 'વેરહાઉસ સફળતાપૂર્વક નિષ્ક્રિય બનાવાયું',
        MarkedAsActive: 'વેરહાઉસ સફળતાપૂર્વક સક્રિય બનાવાયું',
        MarkedAsOP: 'વેરહાઉસ સફળતાપૂર્વક મુખ્ય બનાવાયું',
        WareDeletedSuccess: 'વેરહાઉસ સફળતાપૂર્વક દૂર કરવામાં આવ્યું',
        SuccessfullyUpdatedWarehouse: 'વેરહાઉસ સફળતાપૂર્વક અપડેટ થયું',
        SuccessfullyCreatedWarehouse: 'વેરહાઉસ સફળતાપૂર્વક બનાવાયું',
        EditWarehouse: 'વેરહાઉસ સંપાદિત કરો',
        AddWarehouse: 'વેરહાઉસ ઉમેરો',
        WarehouseNameIsRequired: 'વેરહાઉસનું નામ જરૂરી છે',
        EnterWarehouseName: 'વેરહાઉસનું નામ દાખલ કરો',
        EnterEmail: 'ઇમેલ દાખલ કરો',
        EnterPhoneNumber: 'ફોન નંબર દાખલ કરો',
        Location: 'સ્થાન...',
        name: 'વેરહાઉસનું નામ',
        email: 'ઇમેલ',
        phoneNumber: 'ફોન નંબર',
        location: 'સ્થાન',
        ViewProducts: 'ઉત્પાદનો જુઓ',
        PageTitle: 'ગોદામ',
        noWarehouse: "તમારી શોધ સાથે કોઈ વેરહાઉસ મેળ ખાતું નથી"
    },
    Assets: {
        headerTitle: 'સંપત્તિ',
        addAssetMessage: 'અહીં સંપત્તિ ઉમેરો. કર્મચારીને સંપત્તિ સોંપવા માટે, કર્મચારીની પ્રોફાઇલ પર જાઓ.',
        addAsset: 'સંપત્તિ ઉમેરો',
        editAsset: 'સંપત્તિ સંપાદિત કરો',
        assetCode: 'સંપત્તિ કોડ',
        assetName: 'સંપત્તિનું નામ',
        assetCategory: 'સંપત્તિ શ્રેણી',
        assetType: 'સંપત્તિનો પ્રકાર',
        serialNumber: 'સીરીયલ નંબર',
        location: 'સ્થાન',
        condition: 'સ્થિતિ',
        selectCondition: 'સ્થિતિ પસંદ કરો',
        fair: 'સાધારણ',
        good: 'સારું',
        excellent: 'ઉત્કૃષ્ટ',
        poor: 'નબળું',
        notes: 'નોંધ',
        submit: 'સબમિટ કરો',
        submitting: 'સબમિટ થઈ રહ્યું છે',
        noCategory: 'કોઈ શ્રેણી નથી',
        selectCategory: 'શ્રેણી પસંદ કરો',
        addAssetCat: 'સંપત્તિ શ્રેણી ઉમેરો',
        addAssetCatName: 'સંપત્તિ શ્રેણીનું નામ',
        edit: 'સંપાદિત કરો',
        status: 'સ્થિતિ',
        createdAt: 'બનાવ્યાની તારીખ',
        viewAsset: 'સંપત્તિ જુઓ',
        assignAsset: 'સંપત્તિ સોંપો',
        conditionRet: 'સ્થિતિ (પરત કરતી વખતે)',
        searchSelectAssets: 'સંપત્તિ શોધો/પસંદ કરો',
        assetAssigned: 'સંપત્તિ સફળતાપૂર્વક સોંપાઈ',
        assetReturned: 'સંપત્તિ સફળતાપૂર્વક પરત કરાઈ',
        selectAnAsset: 'કૃપા કરીને એક સંપત્તિ પસંદ કરો',
        action: 'ક્રિયા',
        noAssetAssigned: 'કોઈ સંપત્તિ સોંપાયેલ નથી',
        reAssigned: 'ફરીથી સોંપો',
        assignedAssetsList: 'સોંપાયેલ સંપત્તિઓની યાદી',
        viewHistory: "ઇતિહાસ જુઓ",
        history: "સંપત્તિ ઇતિહાસ",
        loadingHistory: "ઇતિહાસ લોડ થઈ રહ્યો છે...",
        loadingMore: "વધુ લોડ થઈ રહ્યું છે...",
        dateTime: "તારીખ અને સમય",
        staff: "સ્ટાફ",
        AssignedBy: "દ્વારા સોંપાયેલ",
        assign: "સોંપો",
        return: "પરત કરો",
        unknown: "અજ્ઞાત",
        noHistory: "આ એસેટ માટે કોઈ ઇતિહાસ ઉપલબ્ધ નથી.",
        enterReturnNote: "પરત માટે નોંધ દાખલ કરો",
        returnNote: "પરત નોંધ",
        enterAssignNote: "સોંપણી માટે નોંધ દાખલ કરો",
        assignNote: "સોંપણી નોંધ",
        AddNAC: "નવી સંપત્તિ શ્રેણી ઉમેરો",
        EditNAC: "સંપત્તિ શ્રેણી સંપાદિત કરો",
        others: "અન્ય"
    },
    LedgerTransaction: {
        ledgerDetails: 'ખાતાવહી વિગતો',
        productName: 'ઉત્પાદનનું નામ',
        totalQty: 'કુલ જથ્થો',
        date: 'તારીખ',
        receivedAmt: 'પ્રાપ્ત રકમ',
        paid: 'ચૂકવેલ',
        discount: 'છૂટ',
        balance: 'બાકી',
        more: 'વધુ',
        total: 'કુલ',
        ledgerupdatedsuccessfully: 'ખાતાવહી સફળતાપૂર્વક અપડેટ થઈ',
        ledgeraddedsuccessfully: 'ખાતાવહી સફળતાપૂર્વક ઉમેરાઈ',
        viewLedger: 'ખાતાવહી જુઓ',
        edit: 'સંપાદિત કરો',
        create: 'બનાવો',
        Recieved: 'પ્રાપ્ત [સ્ટોકમાં]',
        payMode: 'ચુકવણીનો પ્રકાર',
        Refno: 'સંદર્ભ નંબર'
    },
    ExtraField: {
        attachment: 'જોડાણ',
        acceptOnlyImg: 'માત્ર છબીઓ સ્વીકારો.',
        addAttribute: 'ગુણધર્મ ઉમેરો',
        acceptImgAndDoc: 'છબીઓ અને દસ્તાવેજો સ્વીકારો.'
    },
    phoneInvoiceDownload: {
        Variant: "વેરિઅન્ટ",
        Warehouse: "વેરહાઉસ",
        Bin: "બિન",
        Batch: "બેચ",
        Attributes: "ગુણધર્મો"
    },
    ImportExcel: {
        ImportStockfromExcel: "Excel માંથી સ્ટોક આયાત કરો",
        DragDrop: "તમારી ભરેલી Excel ફાઇલ અહીં ખેંચીને મૂકો અથવા બ્રાઉઝ કરવા માટે ક્લિક કરો",
        DT: "ટેમ્પ્લેટ ડાઉનલોડ કરો",
        GB: "પાછા જાઓ",
        Downloading: "ડાઉનલોડ થઈ રહ્યું છે...",
        ChangeFile: "ફાઇલ બદલો",
        ReadingExcelfile: "Excel ફાઇલ વાંચી રહ્યા છીએ...",
        Processing: "પ્રોસેસિંગ...",
        submitUpdateStock: "સબમિટ કરો અને સ્ટોક અપડેટ કરો",
        downloadLatestTemplate: "નવીનતમ ટેમ્પ્લેટ ડાઉનલોડ કરો",
        loginRequired: "લોગિન જરૂરી છે"
    },
    stockForm: {
        managePayments: "ચુકવણીઓ સંચાલિત કરો",
        invoice: "ઇન્વોઇસ",
        challan: "ચલાન",
        recordPayment: "ચુકવણી નોંધો",
        payableAmount: "ચુકવવાનું રકમ",
        paidAmount: "ચૂકવેલી રકમ",
        paymentMethod: "ચુકવણી પદ્ધતિ",
        paymentDate: "ચુકવણી તારીખ",
        reference: "સંદર્ભ",
        billId: "બિલ નંબર",
        importExcel: "એક્સેલમાંથી આયાત કરો",
        noThanks: "ના, આભાર",
        checkHistory: "ઇતિહાસ જુઓ",
        wantViewHistory: "શું તમે ઇતિહાસ જોવા માંગો છો?",
        enterPayable: "ચુકવવાની રકમ દાખલ કરો",
        enterPaid: "ચૂકવેલી રકમ દાખલ કરો",
        selectPayment: "ચુકવણી પદ્ધતિ પસંદ કરો",
        attachment: "જોડાણ",
        note: "નોંધ"
    },
    HistoryEdit: {
        products: "ઉત્પાદનો",
        add_product: "ઉત્પાદન ઉમેરો",
        paidAmountInvalidMessage: "ચૂકવેલી રકમ ચુકવવાની રકમ કરતાં વધારે હોઈ શકતી નથી",
        removingText: "આ ઉત્પાદન દૂર કરવાથી આ વ્યવહાર દરમિયાન થયેલા સ્ટોક ફેરફારો પાછા ફરશે.",
        remove: "દૂર કરો"
    },
    ExcelProduct: {
        uploadFile: "ફાઇલ અપલોડ કરો",
        dragDrop: "તમારી એક્સેલ ફાઇલ ખેંચો અથવા અપલોડ કરવા ક્લિક કરો.",
        parsingFile: "ફાઇલ વિશ્લેષણ થઈ રહ્યું છે",
        fileSelected: "ફાઇલ પસંદ થઈ ગઈ છે",
        reviewImportedData: "નીચે આયાત કરેલ ડેટા સમીક્ષા કરો. શક્ય હોય ત્યાં કૉલમ આપમેળે મેળ ખાતા થાય છે.",
        changeFile: "ફાઇલ બદલો",
        back: "પાછા",
        invalidFileType: "કૃપા કરીને માન્ય એક્સેલ ફાઇલ અપલોડ કરો (.xlsx અથવા .xls)",
        parseExcelError: "એક્સેલ પાર્સ ભૂલ:",
        noData: "અપલોડ કરેલી એક્સેલ ફાઇલમાં કોઈ ડેટા નથી.",
        failedToRead: "એક્સેલ ફાઇલ વાંચવામાં નિષ્ફળ. ફરી પ્રયાસ કરો.",
        Nodata: "કોઈ_ડેટા_નથી",
        unableToRead: "ફાઇલ વાંચી શકાતી નથી.",
        buyingMustNumber: "ખરીદી કિંમત સંખ્યા હોવી જોઈએ",
        sellingMustNumber: "વેચાણ કિંમત સંખ્યા હોવી જોઈએ",
        mustBeNumber: "સંખ્યા હોવી જોઈએ",
        bulkUploadfailed: "બલ્ક અપલોડ નિષ્ફળ થયું",
        importFromExcel: "એક્સેલમાંથી આયાત કરો",
        generating: "બનાવી રહ્યું છે...",
        downloadTemplate: "ટેમ્પલેટ ડાઉનલોડ કરો",
        uploading: "અપલોડ થઈ રહ્યું છે...",
        done: "પૂર્ણ",
        requiredField: "{field} ફરજિયાત છે",
        bulkUpload: "બલ્ક અપલોડ",
        duplicateSku: "નકલ SKU મળી આવ્યો",
        uploadedSuccessfully: "બધા પ્રોડક્ટ્સ સફળતાપૂર્વક અપલોડ થયા!",
        uploadCompleteIssues: "સમસ્યાઓ સાથે અપલોડ પૂર્ણ થયું",
        uploaded_products: "{count} પ્રોડક્ટ(્સ) અપલોડ થયા.",
        failed_products: "{count} નિષ્ફળ થયા.",
        failed_items: "નિષ્ફળ આઇટમ્સ:"
    },
    Discount: {
        overallDiscount: "કુલ ડિસ્કાઉન્ટ",
        final: "અંતિમ કુલ",
        balanceDue: "બાકી રકમ",
        tax: "કર"
    },
    ProductForm: {
        barcodeQuantity: "બારકોડ જથ્થો દાખલ કરો",
        baseUnit: "મૂળ એકમ (પ્રાથમિક)",
        addSecondaryUnit: "દ્વિતીય એકમ ઉમેરશો?",
        selectUnit: "એકમ પસંદ કરો",
        subUnitDetails: "ઉપ એકમ વિગતો",
        subUnit: "ઉપ એકમ",
        selectSubUnit: "ઉપ એકમ પસંદ કરો",
        conversionRate: "રૂપાંતર દર",
        exampleLogic: "ઉદાહરણ તર્ક:",
        example: "જો તમે પેન બોક્સમાં વેચો છો, તો મૂળ એકમ તરીકે બોક્સ સેટ કરો અને 50 રૂપાંતર સાથે ઉપ એકમ (પીસ) ઉમેરો. એટલે કે 1 બોક્સમાં 50 પીસ હોય છે.",
        basePrice: "મૂળ કિંમત"
    },
    barcode: {
        settings: 'બારકોડ સેટિંગ્સ',
        labelSize: 'લેબલ કદ',
        customSize: 'કસ્ટમ કદ...',
        widthMm: 'પહોળાઈ (mm)',
        heightMm: 'ઊંચાઈ (mm)',
        showPrice: 'લેબલ પર વેચાણ કિંમત બતાવો',
        noPrices: 'આ ઉત્પાદન માટે કોઈ વેચાણ કિંમત ગોઠવેલ નથી.',
        preview: 'પૂર્વાવલોકન',
        generate: 'જનરેટ કરો',
        label: 'લેબલ',
        singlePage: 'સિંગલ પેજ',
        downloadOptions: 'ડાઉનલોડ વિકલ્પો',
        chooseLayout: 'બારકોડ માટે લેઆઉટ પસંદ કરો',
        allInSinglePage: 'બધા બારકોડ સિંગલ પેજમાં ઉમેરો.',
        allInA4Grid: 'બધા સિંગલ પેજમાં',
        allInA4GridSub: 'બધા બારકોડને A4 ગ્રીડમાં ગોઠવે છે',
        onePerPage: 'પેજ દીઠ એક',
        onePerPageSub: 'દરેક બારકોડ તેના પોતાના લેબલ પેજ પર',
        downloadBarcode: 'બારકોડ ડાઉનલોડ કરો'
    },

    TransferItem: {
        transferItem: "આઇટમ ટ્રાન્સફર",
        Date: "તારીખ",
        Reason: "કારણ",
        enterReason: "કારણ દાખલ કરો",
        Name: "નામ",
        QuantityTransfered: "ટ્રાન્સફર કરેલી માત્રા",
        SWarehouse: "સ્ત્રોત ગોદામ",
        SelectSWarehouse: "સ્ત્રોત ગોદામ પસંદ કરો",
        DWarehouse: "ગંતવ્ય ગોદામ",
        SelectDWarehouse: "ગંતવ્ય ગોદામ પસંદ કરો",
        CreatedBy: "બનાવનાર",
        CreatedTime: "બનાવવાનો સમય",
        UpdatedTime: "અપડેટ સમય",
        NoOrderFound: "કોઈ ઓર્ડર મળ્યો નથી",
        New: "નવું",
        WarehouseItemTransfer: "ગોદામ આઇટમ ટ્રાન્સફર",
        TotalTransfers: "કુલ ટ્રાન્સફર",
        EnterReason: "કારણ દાખલ કરો",
        ItemDetails: "આઇટમ વિગતો",
        CurrentAvailable: "હાલમાં ઉપલબ્ધ",
        TransferQty: "ટ્રાન્સફર માત્રા",
        SStock: "સ્ત્રોત સ્ટોક",
        DStock: "ગંતવ્ય સ્ટોક",
        addDescription: "આઇટમ માટે વર્ણન ઉમેરો",
        selectVariant: "વેરિઅન્ટ પસંદ કરો",
        addNewRow: "નવી પંક્તિ ઉમેરો",
        typeOrSelectItem: "શોધવા માટે ટાઇપ કરો",
        scrollToLoadMore: "વધુ લોડ કરવા સ્ક્રોલ કરો",
        noProductsFound: "કોઈ પ્રોડક્ટ મળી નથી",
        selectWarehouse: "ગોદામ પસંદ કરો"
    },
    Sku: {
        searchSelectProduct: "પ્રોડક્ટ શોધો / પસંદ કરો",
        searchSelectSku: "SKU શોધો / પસંદ કરો",
        noSkuFound: "કોઈ SKU મળ્યો નથી"
    },
    HistoryPage: {
        addFilter: "ફિલ્ટર ઉમેરો",
        filtersActive: "બધા ફિલ્ટર સક્રિય છે",
        noProducts: "કોઈ પ્રોડક્ટ નથી",
        download: "ડાઉનલોડ",
        recentlyUpdated: "હાલમાં અપડેટ થયેલ",
    },
    StockPage: {
        challanNumber: "ચાલાન નંબર",
        subTotal: "ઉપ કુલ",
        totalTaxes: "કુલ અને કર",
        taxInclusive: "કર સહિત",
        discountedValue: "ડિસ્કાઉન્ટ પછીનું મૂલ્ય",
        taxValue: "કર મૂલ્ય",
        totalAmount: "કુલ રકમ",
        close: "બંધ",
        addTax: "કર ઉમેરો",
        label: "લેબલ",
        enterLabel: "લેબલ દાખલ કરો",
        taxRate: "કર દર",
        enterTaxRate: "કર દર દાખલ કરો",
        selectTaxRate: "કર દર પસંદ કરો",
        addNewTax: "નવો કર દર ઉમેરો",
        discountProducts: "ડિસ્કાઉન્ટ પછીનું મૂલ્ય (ઉત્પાદનો)",
        taxProducts: "કર મૂલ્ય (ઉત્પાદનો)",
        clickAddPayment: "ચુકવણી ઉમેરવા ક્લિક કરો",
        paidGreaterPayable: "ચુકવેલ રકમ ચૂકવવાની રકમથી વધુ હોઈ શકે નહીં",
        vendorCompulsory: "ચુકવણી નોંધવા માટે વેચનાર જરૂરી છે",
        customerCompulsory: "ચુકવણી નોંધવા માટે ગ્રાહક જરૂરી છે",
        updateInvoiceFormat: "ઇન્વૉઇસ ફોર્મેટ અપડેટ કરો",
        updateChallanFormat: "ચાલાન ફોર્મેટ અપડેટ કરો",
        addPrefix: "પ્રિફિક્સ ઉમેરો",
        prefix: "પ્રિફિક્સ"
    },
    EditHistoryPage: {
        search_by_notes: "નોટ્સ દ્વારા શોધો",
        alertMessage: "આ ફેરફાર માત્ર ઇતિહાસમાં નોંધાયો છે અને વર્તમાન સ્ટોકને અસર કરતો નથી.",
        paymentDetails: "ચુકવણી વિગતો",
        units: "એકમો",
        customLabels: "કસ્ટમ લેબલ્સ",
        value: "મૂલ્ય"
    },
    historyCard: {
        paid: "ચુકવેલ",
        partiallyPaid: "આંશિક રીતે ચુકવેલ",
        billDate: "બિલ તારીખ",
        productDetails: "ઉત્પાદન વિગતો",
        paymentsHistory: "ચુકવણી ઇતિહાસ",
        updatePayment: "ચુકવણી અપડેટ કરો",
        discounts: "ડિસ્કાઉન્ટ",
        inclusive: "(સમાવેલ)",
        discountOverall: "ડિસ્કાઉન્ટ પછીનું મૂલ્ય (કુલ)",
        dueAmount: "બાકી રકમ",
        enterPaid: "ચુકવેલ રકમ દાખલ કરો",
        enterReference: "સંદર્ભ દાખલ કરો",
        enterNote: "નોટ દાખલ કરો",
        enterInvoice: "ઇન્વૉઇસ દાખલ કરો",
        enterChallan: "ચાલાન દાખલ કરો",
        edit: "સંપાદિત"
    },
    printInvoice: {
        billTo: "બિલ માટે",
        ref: "સંદર્ભ નં.",
        mode: "મોડ",
        date: "તારીખ",
        amount: "રકમ",
        totalPaid: "કુલ ચુકવેલ"
    },
    Contact: {
        supplier_required: "સ્ટોક ઇન માટે સપ્લાયર જરૂરી છે",
        customer_required: "સ્ટોક આઉટ માટે ગ્રાહક જરૂરી છે",
        key: "કી",
        editHistory: "ઇતિહાસ સંપાદિત કરો",
        loading: "લોડ થઈ રહ્યું છે..."
    },
    AW: {
        availablewarehouse: "ઉપલબ્ધ વેરહાઉસ",
        visibilityManagement: 'દૃશ્યતા વ્યવસ્થાપન',
        availablewarehouses: "ઉપલબ્ધ વેરહાઉસો",
        Active: "સક્રિય",
        LWarehouse: "વેરહાઉસ લોડ થઈ રહ્યા છે...",
        NWForthisProduct: "આ પ્રોડક્ટ માટે કોઈ વેરહાઉસ મળ્યું નથી.",
        of: "ના",
        WarehouseAvailabilty: "વેરહાઉસ ઉપલબ્ધતા",
    },
    Currency: {
        searchCurrency: "કરન્સી શોધો...",
        addCurrency: "કરન્સી ઉમેરો",
        addNewCurrency: "નવી કરન્સી ઉમેરો",
        editCurrency: "કરન્સી સંપાદિત કરો",
        currencySymbol: "કરન્સી ચિહ્ન",
        currencyName: "કરન્સી નામ",
        enterCurrencySymbol: "કરન્સી ચિહ્ન દાખલ કરો",
        enterCurrencyName: "કરન્સી નામ દાખલ કરો"
    },
    NewReportLang: {
        DM: "દૈનિક હલનચલન",
        WR: "વેરહાઉસ રિપોર્ટ",
        PDM: "ઉત્પાદન દૈનિક હલનચલન",
        TBP: "કુલ ખરીદ કિંમત",
        TPQ: "કુલ ઉત્પાદન જથ્થો",
        TP: "કુલ ઉત્પાદનો",
        CS: "વર્તમાન સ્ટોક",
        IV: "ઇન્વેન્ટરી મૂલ્ય",
        DA: "દૈનિક સરેરાશ",
        TSI: "કુલ સ્ટોક ઇન",
        TSO: "કુલ સ્ટોક આઉટ",
        TOR: "ટર્નઓવર દર",
        Tv: "કુલ મૂલ્ય",
        AST: "સક્રિય SKU ટ્રેકિંગ",
        UT: "ટ્રેક કરેલા એકમો",
        SL: "સ્ટોક સ્તર",
        Value: "મૂલ્ય",
        IO: "ઇન/આઉટ",
        T: "ટર્નઓવર",
        unitsD: "એકમો/દિવસ",
        Sort: "ક્રમબદ્ધ કરો",
        Sort_by: "આ પ્રમાણે ક્રમબદ્ધ કરો",
        Units_available: "ઉપલબ્ધ એકમો",
        Units_unavailable: "ઉપલબ્ધ નથી એકમો",
        Current_assets: "ચાલુ મિલકતો",
        Search: "શોધો",
        available: "ઉપલબ્ધ",
        assigned: "સોંપેલ",
        AYSWD: "શું તમે ખરેખર કાઢી નાખવા માંગો છો?",
        PTS: "વેરહાઉસ સફળતાપૂર્વક ટ્રાન્સફર થયું",
        AUS: "એસેટ્સ સફળતાપૂર્વક અપડેટ થયા",
        ACS: "એસેટ્સ સફળતાપૂર્વક બનાવાયા",
        VSP: "વેચાણ કિંમત જુઓ",
        HUS: "ઇતિહાસ સફળતાપૂર્વક અપડેટ થયો",
    },
    ReplacementReturn: {
        selectProduct: "કૃપા કરીને એક ઉત્પાદન પસંદ કરો",
        selectReplacementProduct: "ઓછામાં ઓછું એક રિપ્લેસમેન્ટ ઉત્પાદન પસંદ કરો",
        validQuantity: "માન્ય રિટર્ન જથ્થો દાખલ કરો",
        replacedSuccessfully: "ઉત્પાદન સફળતાપૂર્વક બદલાયું",
        returnSuccessfully: "ઉત્પાદન સફળતાપૂર્વક પરત કરાયું",
        failedProcess: "પ્રક્રિયા નિષ્ફળ. કૃપા કરીને ફરીથી પ્રયાસ કરો.",
        return: "પરત",
        replace: "બદલો",
        typeSelectProduct: "ઉત્પાદન ટાઇપ કરો અથવા પસંદ કરો...",
        returnQuantity: "પરત જથ્થો",
        enterQuantity: "જથ્થો દાખલ કરો",
        replacementDate: "રિપ્લેસમેન્ટ તારીખ",
        returnDate: "પરત તારીખ",
        chooseCustomer: "ગ્રાહક પસંદ કરો",
        additionalNotes: "વધારાની નોંધો ઉમેરો...",
        replacementProducts: "રિપ્લેસમેન્ટ ઉત્પાદનો",
        addProducts: "વધુ ઉત્પાદનો ઉમેરો",
        tapSelect: "ઉપલબ્ધ ઉત્પાદનોમાંથી પસંદ કરવા માટે ટેપ કરો",
        currently: "હાલમાં",
        item: "આઇટમ",
        items: "આઇટમ્સ",
        selected: "પસંદ કરેલ",
        selectedItems: "પસંદ કરેલ આઇટમ્સ",
        hideDetails: "વધુ વિગતો છુપાવો",
        showDetails: "વધુ વિગતો બતાવો",
        product: "ઉત્પાદન",
        priceLevel: "કિંમત સ્તર પસંદ કરો",
        customPrice: "કસ્ટમ કિંમત દાખલ કરો",
        noReplaceHistory: "કોઈ રિપ્લેસમેન્ટ ઇતિહાસ મળ્યો નથી",
        replaceReturn: "બદલો અને પરત કરો",
        replaceReturnHistory: "બદલી અને પરત કરવાનો ઇતિહાસ"
    },
    OtherComponent: {
        mfgHistoryTitle: "ઉત્પાદન ઇતિહાસ",
        mfgHistoryDesc: "ઉત્પાદિત સ્ટોક ઉત્પાદનો ટ્રૅક કરો",
        dailyOperation: "દૈનિક કાર્યો",
        freqUsed: "રેકોર્ડને ઝડપથી અપડેટ કરવા માટે વારંવાર વપરાતી ક્રિયાઓ",
        manageCategory: "કેટેગરીઝનું સંચાલન કરો",
        organizeCaterory: "પ્રોડક્ટ, ખર્ચ અને એસેટ કેટેગરીઝને વ્યવસ્થિત અને સંચાલિત કરો",
        businessRecord: "વ્યવસાયિક રેકોર્ડ્સ",
        organizeRecord: "તમારા વ્યવસાયિક રેકોર્ડ્સને વ્યવસ્થિત અને સંચાલિત કરો",
        trackHistory: "ઇતિહાસ ટ્રેક કરો",
        completeTracking: "ઓડિટ અને ટ્રેકિંગ માટે સંપૂર્ણ ઇતિહાસ",
        Verifyinventorycount: "ઇન્વેન્ટરી ગણતરી ચકાસો",
        Exchangerates: "વિનિમય દર",
        Productiontracking: "ઉત્પાદન ટ્રેકિંગ",
        Fixedassetregister: "સ્થિર સંપત્તિ રજિસ્ટર",
        Storagelocations: "સ્ટોરેજ સ્થાનો",
        warehouseAvailability: 'વેરહાઉસ-સ્તરના ઉત્પાદનની ઉપલબ્ધતા',
        Logreviewspend: "ખર્ચ લોગ અને સમીક્ષા કરો",
        Productgroupings: "પ્રોડક્ટ ગ્રુપિંગ",
        Classifyexpenditures: "ખર્ચનું વર્ગીકરણ કરો",
        Assetclassification: "એસેટ વર્ગીકરણ",
        Manageexchanges: "વિનિમયનું સંચાલન કરો",
        Returnauditlog: "રિટર્ન ઓડિટ લોગ",
        Interlocationmoves: "આંતર-સ્થાન સ્થાનાંતરણ",
        Manageoperationscategoriesrecordsandhistory: "ઓપરેશન્સ, કેટેગરીઝ, રેકોર્ડ્સ અને ઇતિહાસનું સંચાલન કરો"
    },
    no_permission_dialog: {
        title: 'કોઈ પરવાનગી નથી',
        historyDescription: "તમને વ્યવહાર ઇતિહાસ જોવાની પરવાનગી નથી. કૃપા કરીને તમારા એડમિનિસ્ટ્રેટરનો સંપર્ક કરો.",
        replacementHistoryDescription: "તમને રિપ્લેસમેન્ટ અને રિટર્ન ઇતિહાસ જોવાની પરવાનગી નથી. કૃપા કરીને તમારા એડમિનિસ્ટ્રેટરનો સંપર્ક કરો.",
        transferHistoryDescription: "તમને ટ્રાન્સફર વેરહાઉસ ઇતિહાસ જોવાની પરવાનગી નથી. કૃપા કરીને તમારા એડમિનિસ્ટ્રેટરનો સંપર્ક કરો."
    },
    OthersHistory: {
        title: "ઇતિહાસ મેનેજ કરો",
        transferHistory: "ટ્રાન્સફર ઇતિહાસ મેનેજ કરો",
        transactionHistory: "વ્યવહાર ઇતિહાસ મેનેજ કરો",
        replacementHistory: "રિપ્લેસમેન્ટ અને રિટર્ન ઇતિહાસ મેનેજ કરો"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "વ્યવસાય દ્વારા શેર કરાયેલા ઉત્પાદનો જુઓ અને ખરીદો.",
        description: "વ્યવસાય દ્વારા શેર કરાયેલા ઉત્પાદનો જુઓ.",
        productsAvailable: "ઉપલબ્ધ ઉત્પાદનો",
        noImageAvailable: "કોઈ છબી ઉપલબ્ધ નથી",
        productDetails: "ઉત્પાદન વિગતો",
        inStock: "સ્ટોકમાં ઉપલબ્ધ",
        availableVariants: "ઉપલબ્ધ વિકલ્પો",
        options: "વિકલ્પો",
        orders: "ઓર્ડર્સ"
    ,
        searchProducts: "પ્રોડક્ટ શોધો...",
        noProductsFound: "કોઈ પ્રોડક્ટ મળ્યું નથી",
        tryDifferentKeyword: "અલગ શબ્દ સાથે શોધવાનો પ્રયાસ કરો",
        variants: "વેરિએન્ટ",
        stock: "સ્ટોક",
        cart: "કાર્ટ",
        products: "પ્રોડક્ટ્સ",
        viewCart: "કાર્ટ જુઓ",
        backToProducts: "પ્રોડક્ટ્સ પર પાછા",
        yourCart: "તમારું કાર્ટ",
        clear: "સાફ કરો",
        cartEmpty: "તમારું કાર્ટ ખાલી છે",
        cartEmptyDesc: "કેટલોગ જુઓ અને તમે ઓર્ડર કરવા ઇચ્છો છો તે પ્રોડક્ટ ઉમેરો.",
        browseProducts: "પ્રોડક્ટ્સ જુઓ",
        selectedItems: "પસંદ કરેલ આઇટમ",
        itemInCart: "આઇટમ કાર્ટમાં",
        itemsInCart: "આઇટમ કાર્ટમાં",
        customerDeliveryDetails: "ગ્રાહક અને ડિલિવરી વિગતો",
        fullName: "પૂરું નામ",
        enterFullName: "તમારું પૂરું નામ દાખલ કરો",
        deliveryAddress: "ડિલિવરી સરનામું",
        addressPlaceholder: "શેરી, ઇમારત, શહેર, પિન કોડ...",
        orderNote: "ઓર્ડર નોંધ (વૈકલ્પિક)",
        orderNotePlaceholder: "ખાસ સૂચનાઓ અથવા ડિલિવરી નોંધ...",
        paymentMode: "ચૂકવણી મોડ",
        subtotal: "પેટા-કુલ",
        items: "આઇટમ",
        totalAmount: "કુલ રકમ",
        orderOnWhatsApp: "WhatsApp પર ઓર્ડર કરો 📲",
        orderPlaced: "ઓર્ડર સફળતાપૂર્વક આપ્યો! 🎉",
        orderPlacedDesc: "તમારો ઓર્ડર નોંધાયો છે અને WhatsApp ખોલવામાં આવ્યું છે.",
        continueShopping: "ખરીદી ચાલુ રાખો 🛍️",
        cartEmptyTitle: "કાર્ટ ખાલી છે",
        cartEmptyToast: "ચેકઆઉટ પહેલાં કૃપા કરીને પ્રોડક્ટ ઉમેરો.",
        incompleteTitle: "અધૂરી વિગતો",
        incompleteToast: "ઓર્ડર આપતા પહેલાં કૃપા કરીને બધા જરૂરી ફીલ્ડ ભરો.",
        nameRequired: "પૂરું નામ જરૂરી છે",
        addressRequired: "ડિલિવરી સરનામું જરૂરી છે",
        catalogUnavailable: "કેટલોગ હાલમાં ઉપલબ્ધ નથી",
        catalogUnavailableDesc: "આ કેટલોગ હાલમાં સક્રિય નથી. વ્યવસાયનો સંપર્ક કરો.",
        invalidCatalogLink: "અમાન્ય કેટલોગ લિંક 🚫",
        invalidCatalogDesc: "આ કેટલોગ પેજમાં જરૂરી માહિતી ખૂટે છે.",
        missing: "ખૂટે છે",
        catalogSlug: "કેટલોગ સ્લગ",
        goBackHome: "હોમ પર પાછા જાઓ",
        inventoryManagement: "ઇન્વેન્ટરી મેનેજમેન્ટ અને ઇન્વોઇસિંગ 🚀 Simply",
        enter: "દાખલ કરો",
        select: "પસંદ કરો",
        // Catalog Order translations
        catalogOrders: 'કેટલોગ ઓર્ડર',
        pending: 'બાકી',
        converted: 'રૂપાંતરિત',
        cancelled: 'રદ કરેલ',
        totalRevenue: 'કુલ મૂલ્ય',
        totalCatalogOrders: 'કુલ ઓનલાઇન ઓર્ડર',
        convertToSalesOrder: 'વેચાણ ઓર્ડરમાં રૂપાંતરિત કરો',
        date: 'તારીખ',
        status: 'સ્થિતિ',
        action: 'ક્રિયા',
        searchOrders: 'ગ્રાહક અથવા ફોન શોધો...',
        noMatchingOrders: 'મેળ ખાતા ઓર્ડર મળ્યા નથી',
        noStatusOrders: 'કોઈ {status} ઓર્ડર મળ્યા નથી',
        tryDifferentSearch: 'અલગ ગ્રાહક નામ અથવા ફોન નંબર સાથે શોધવાનો પ્રયાસ કરો.',
        noOrdersWithStatus: 'હાલમાં {status} સ્થિતિ સાથે કોઈ ઓર્ડર નથી.',
        noOrdersYet: 'હજુ કોઈ કેટલોગ ઓર્ડર નથી',
        noOrdersDescription: 'તમારા ઓનલાઇન કેટલોગમાંથી મૂકેલા ઓર્ડર અહીં દેખાશે.',
        guestCustomer: 'મહેમાન ગ્રાહક',
        item: 'વસ્તુ',
        moreItems: '+{count} વધુ',
        viewDetails: 'વિગતો જુઓ',
        viewSalesOrder: 'વેચાણ ઓર્ડર જુઓ',
        cancelOrder: 'ઓર્ડર રદ કરો',
        confirmCancelTitle: 'કેટલોગ ઓર્ડર રદ કરવો?',
        confirmCancelOrder: 'શું તમે ખરેખર આ ઓર્ડર રદ કરવા માગો છો? આ ક્રિયા પૂર્વવત કરી શકાતી નથી.',
        keepOrder: 'ના, ઓર્ડર રાખો',
        confirmCancelAction: 'હા, ઓર્ડર રદ કરો',
        orderNotFound: 'કેટલોગ ઓર્ડર મળ્યો નથી',
        orderNotFoundDescription: 'આ ઓર્ડર શોધી શકાયો નથી અથવા તમને તે જોવાની પરવાનગી ન હોઈ શકે.',
        backToCatalogOrders: 'કેટલોગ ઓર્ડર પર પાછા જાઓ',
        placedOn: 'ઓર્ડર તારીખ',
        totalItems: 'કુલ વસ્તુઓ',
        orderedProducts: 'ઓર્ડર કરેલા ઉત્પાદનો',
        itemDetails: 'વસ્તુની વિગતો',
        quantity: 'જથ્થો',
        unitPrice: 'એકમ કિંમત',
        total: 'કુલ',
        variant: 'વેરિઅન્ટ',
        customerInformation: 'ગ્રાહક માહિતી',
        additionalFields: 'વધારાના ફીલ્ડ',
        fields: 'ફીલ્ડ',
    },
    stockNew: {
        Npay: "હજુ સુધી કોઈ ઉત્પાદનો ઉમેરાયા નથી",
        emptydesc: "તમારા કેટલોગમાંથી એક ઉત્પાદન પસંદ કરો અને સ્ટોક રેકોર્ડ કરવા માટે આવતી માત્રા દાખલ કરો.",
        tipText: "ટિપ: તમે એક્સેલ ફાઇલ પણ અપલોડ કરી શકો છો",
        OT: "ઓર્ડરનું કુલ",
        Collapse: "સંકુચિત કરો"
    },
    deleteBulk: {
        Bulkoperation: "બલ્ક ઑપરેશન",
        Applyproducts: "બહુવિધ ઉત્પાદનો પર ક્રિયાઓ લાગુ કરો",
        Bulkupload: "બલ્ક અપલોડ",
        ImportCSVfile: "એક્સેલ અથવા CSV ફાઇલ દ્વારા ઉત્પાદનો આયાત કરો",
        or: "અથવા",
        Bulkdelete: "બલ્ક ડિલીટ",
        Permanentlyallproducts: "તમામ ઉત્પાદનો કાયમ માટે દૂર કરો",
        IrrText: "બલ્ક ડિલીટ પરત લઈ શકાય તેમ નથી. જરૂર હોય તો પહેલા બેકઅપ એક્સપોર્ટ કરો.",
        SeP: "પસંદ કરેલ ઉત્પાદનો",
        sP: "ઉત્પાદન પસંદ કરો",
        DA: "બધું ડિલીટ કરો",
        DP: "ઉત્પાદનો ડિલીટ કરો",
        sL: "બધું પસંદ કરો",
        ASDE: "શું તમે ખરેખર બધા ઉત્પાદનોને છોડીને ડિલીટ કરવા માંગો છો",
        ASDAllP: "શું તમે ખરેખર તમામ ઉત્પાદનો ડિલીટ કરવા માંગો છો?",
        ASD: "શું તમે ખરેખર ડિલીટ કરવા માંગો છો",
        products: "ઉત્પાદનો",
        TACBU: "આ ક્રિયા પાછી ખેંચી શકાતી નથી.",
        LP: "ઉત્પાદનો લોડ થઈ રહ્યા છે...",
        FM: "વધુ લાવવામાં આવી રહ્યા છે...",
        NPF: "કોઈ ઉત્પાદનો મળ્યા નથી.",
        LMP: "વધુ ઉત્પાદનો લોડ થઈ રહ્યા છે..."
    },
    NewVariantModal: {
        Definevariantsassign: "વેરિઅન્ટ્સ વ્યાખ્યાયિત કરો અને જથ્થો સોંપો",
        Nothingallocated: "કંઈ સોંપાયું નથી",
        Overallocated: "અતિશય સોંપાયેલ",
        Fullyallocated: "સંપૂર્ણ સોંપાયેલ",
        Overby: "અતિરિક્ત દ્વારા",
        Allvariantsneedaname: "બધા વેરિઅન્ટ્સને નામની જરૂર છે.",
        Reducequantities: "જથ્થો ઘટાડો.",
        Overallocatedby: "અતિશય સોંપાયેલ દ્વારા",
        Quantitiesmustmatchthetotalavailability: "જથ્થો કુલ ઉપલબ્ધતા સાથે મેળ ખાવો જોઈએ.",
        Allocatequantitiesacrosswarehouses: "વેરહાઉસમાં જથ્થો વહેંચો",
        Notfullydistributed: "સંપૂર્ણ વિતરિત નથી:",
        remaining: "બાકી",
        Qty: "જથ્થો",
        Inactive: "નિષ્ક્રિય",
        left: "બાકી"
    },
    ProductFormNew: {
        BasicInfo: "મૂળભૂત માહિતી",
        ProductImage: "ઉત્પાદન ચિત્ર",
        Images: "ચિત્રો",
        Pricing: "ભાવ",
        Everypriceneedsbothalabelandanamount: "દરેક કિંમતને લેબલ અને રકમ બંનેની જરૂર છે",
        AddalabellikeWholesaleorRetailtoidentifythisprice: '"જથ્થાબંધ" અથવા "રિટેલ" જેવું લેબલ ઉમેરો આ કિંમત ઓળખવા માટે',
        Entertheamountforthisprice: "આ કિંમત માટે રકમ દાખલ કરો",
        AddMultiplePrice: "બહુવિધ ભાવ ઉમેરો",
        NoPhotosLetAiFind: "કોઈ ફોટા નથી? AI ને ઉત્પાદન છબીઓ શોધવા દો",
        AddProductImagesTitle: "ઉત્પાદન છબીઓ ઉમેરો",
        ChooseHowToAddPhotos: "આ ઉત્પાદન માટે તમે ફોટા કેવી રીતે ઉમેરવા માંગો છો તે પસંદ કરો:",
        SearchWithAi: "AI સાથે શોધો",
        SearchWithAiDesc: "AI નો ઉપયોગ કરીને આપમેળે ઉત્પાદન છબીઓ શોધો અને પસંદ કરો",
        FilesFileExplorer: "ફાઇલો (ફાઇલ એક્સપ્લોરર)",
        FilesFileExplorerDesc: "સીધા તમારા કમ્પ્યુટર પરથી છબીઓ પસંદ કરો",
        AiProductImageFinder: "AI ઉત્પાદન છબી શોધક",
        AiProductImageFinderDesc: "તમારા ઉત્પાદન માટે છબીઓ શોધો અને પસંદ કરો",
        TypeProductNamePlaceholder: "ઉત્પાદનનું નામ લખો...",
        SearchForYourProduct: "તમારા ઉત્પાદન શોધો",
        SearchForYourProductHint: "બ્રાન્ડ અથવા ઉત્પાદનનું નામ અજમાવો",
        ImagesSelected: "છબીઓ પસંદ કરી",
        AddSelected: "પસંદ કરેલ ઉમેરો"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "નવું કસ્ટમ ફીલ્ડ વ્યાખ્યાયિત કરો",
        AttributeName: "એટ્રિબ્યુટ નામ",
        DataType: "ડેટા પ્રકાર",
        Noattributesfound: "કોઈ એટ્રિબ્યુટ મળ્યા નથી",
        ManageAttributes: "એટ્રિબ્યુટ્સ મેનેજ કરો",
        Editordeleteexistingattributes: "હાલના એટ્રિબ્યુટ્સમાં ફેરફાર અથવા કાઢી નાખો",
        UpdateAttribute: "એટ્રિબ્યુટ અપડેટ કરો",
        Saving: "સાચવી રહ્યું છે..."
    },
    NewExpenses: {
        Noexpensesyet: "હજુ સુધી કોઈ ખર્ચ નથી",
        Addyourfirstexpensetostarttrackingyourspending: "તમારા ખર્ચને ટ્રેક કરવાનું શરૂ કરવા માટે તમારો પ્રથમ ખર્ચ ઉમેરો.",
        TOTALEXPENSES: "કુલ ખર્ચ",
        ENTRIES: "એન્ટ્રીઝ",
        BYCATEGORY: "કેટેગરી અનુસાર",
        Nocategoriestodisplay: "દર્શાવવા માટે કોઈ કેટેગરી નથી",
        DateanfTime: "તારીખ અને સમય"
    },
    PurchaseSales: {
        CancelOrder: "ઓર્ડર રદ કરો",
        ReopenOrder: "ઓર્ડર ફરીથી ખોલો",
        Reopen: "ફરીથી ખોલો",
        ConfirmCancelOrder: "શું તમે ખરેખર આ ઓર્ડર રદ કરવા માંગો છો?",
        ConfirmReopenOrder: "શું તમે ખરેખર આ ઓર્ડર ફરીથી ખોલવા માંગો છો?",
        OrderCancelledSuccessfully: "ઓર્ડર સફળતાપૂર્વક રદ થયો.",
        OrderReopenedSuccessfully: "ઓર્ડર સફળતાપૂર્વક ફરીથી ખોલાયો.",
        CancelledBy: "દ્વારા રદ",
        Cancelled: "રદ",
        AccessDenied: "પ્રવેશ નકારાયો",
        YouDonthaeP: "આ પૃષ્ઠ જોવાની તમને પરવાનગી નથી. જો તમને લાગે કે આ ભૂલ છે, તો કૃપા કરીને તમારા એડમિનિસ્ટ્રેટરનો સંપર્ક કરો.",
        purchase: "ખરીદી",
        sales: "વેચાણ",
        Areyousureyouwantto: "શું તમે ખરેખર ઇચ્છો છો કે",
        Thisactionwillupdateitsstatus: "આ ક્રિયા તેની સ્થિતિ અપડેટ કરશે.",
        ReasonOPtional: "કારણ (વૈકલ્પિક)",
        Enterareasonfor: "માટે કારણ દાખલ કરો",
        optionalDot: "(વૈકલ્પિક)...",
        Reject: "નકારો",
        ConfirmOrder: "ઓર્ડરની પુષ્ટિ કરો",
        RejectOrder: "ઓર્ડર નકારો",
        Previous: "પહેલાનું",
        First: "પ્રથમ",
        Order: "ઓર્ડર",
        Items: "આઇટમ્સ",
        Memo: "મેમો",
        SelectDateRange: "તારીખની શ્રેણી પસંદ કરો",
        List: "યાદી",
        Board: "બોર્ડ",
        View: "જુઓ",
        CreateSalesOrder: "વેચાણ ઓર્ડર બનાવો",
        CreatePurchaseOrder: "ખરીદી ઓર્ડર બનાવો",
        successfully: "સફળતાપૂર્વક",
        ManageAttachments: "જોડાણોનું સંચાલન કરો",
        SelectItemsFirst: "કૃપા કરીને પહેલા ઓછામાં ઓછી એક આઇટમ પસંદ કરો",
        PaymentMarkedPendingDesc: "ચુકવણી બાકી તરીકે ચિહ્નિત થયેલ છે. હમણાં ચુકવણી રેકોર્ડ કરવા માટે 'ચુકવણીને બાકી તરીકે ચિહ્નિત કરો' અનચેક કરો.",
        SelectCustomerAndItemFirst: "કૃપા કરીને પહેલા ગ્રાહક અને ઓછામાં ઓછી એક વસ્તુ પસંદ કરો",
        SelectSupplierAndItemFirst: "કૃપા કરીને પહેલા સપ્લાયર અને ઓછામાં ઓછી એક વસ્તુ પસંદ કરો",
        SelectCustomerProductFirst: "પહેલા ગ્રાહક અને ઉત્પાદ પસંદ કરો",
        SelectSupplierProductFirst: "પહેલા સપ્લાયર અને ઉત્પાદ પસંદ કરો",
        Receivables: "લેણાં",
        Payables: "દેવાં",
        Stockoutitemsimmediatelyaftersaving: "સેવ કર્યા પછી તરત જ આઇટમ્સ સ્ટોક આઉટ કરો.",
        Stockinitemsimmediatelyaftersavingthisorder: "આ ઓર્ડર સેવ કર્યા પછી તરત જ આઇટમ્સ સ્ટોક ઇન કરો.",
        ViewAttachments: "જોડાણો જુઓ",
        MemoAttachments: "મેમો અને જોડાણો",
        ReceivedDate: "પ્રાપ્તિ તારીખ",
        ShippedDate: "શિપિંગ તારીખ",
        OrderDate: "ઓર્ડર તારીખ",
        OrderDetails: "ઓર્ડર વિગતો",
        Subtotal: "પેટાકુલ",
        OrderSummary: "ઓર્ડર સારાંશ",
        AddItem: "આઇટમ ઉમેરો",
        NewSalesOrder: "નવો વેચાણ ઓર્ડર",
        NewPurchaseOrder: "નવો ખરીદી ઓર્ડર",
        Createandmanageyour: "બનાવો અને સંચાલન કરો તમારા",
        orders: "ઓર્ડર્સ",
        Removeitem: "આઇટમ દૂર કરો",
        UnitPrice: "એકમ ભાવ",
        PurchaseOrder: "ખરીદી ઓર્ડર",
        SalesOrder: "વેચાણ ઓર્ડર",
        PurchaseInvoice: "ખરીદી ઇન્વોઇસ",
        SalesInvoice: "વેચાણ ઇન્વોઇસ",
        PurchaseOrdernotfound: "ખરીદી ઓર્ડર મળ્યો નથી",
        Approve: "મંજૂરી આપો",
        MarkasShipped: "શિપ્ડ તરીકે ચિહ્નિત કરો",
        MarkasReceived: "પ્રાપ્ત તરીકે ચિહ્નિત કરો",
        Marking: "ચિહ્નિત કરી રહ્યું છે...",
        PartiallyShip: "આંશિક શિપ",
        PartiallyReceive: "આંશિક પ્રાપ્તિ",
        Deleting: "કાઢી રહ્યું છે...",
        Transaction: "વ્યવહાર",
        Details: "વિગતો",
        Item: "આઇટમ",
        Received: "પ્રાપ્ત",
        Shipped: "શિપ્ડ",
        Ordered: "ઓર્ડર કરેલ",
        units: "એકમો",
        Overalldiscount: "એકંદર ડિસ્કાઉન્ટ",
        Transactions: "વ્યવહારો",
        Notransactionsfound: "કોઈ વ્યવહાર મળ્યો નથી",
        OrderedQty: "ઓર્ડર કરેલ જથ્થો",
        Totalqty: "કુલ જથ્થો",
        StockingOut: "સ્ટોક આઉટ થઈ રહ્યું છે...",
        StockingIn: "સ્ટોક ઇન થઈ રહ્યું છે...",
        thiorderUpdateStuau: "આ ઓર્ડર? આ ક્રિયા તેની સ્થિતિ અપડેટ કરશે.",
        TransactionDetails: "વ્યવહાર વિગતો",
        Fetchingtransactiondetails: "વ્યવહાર વિગતો લાવી રહ્યું છે...",
        Nodetailsfoundforthistransaction: "આ વ્યવહાર માટે કોઈ વિગતો મળી નથી.",
        TotalBreakDown: "કુલ બ્રેકડાઉન",
        ChangeAmount: "બદલાતી રકમ",
        Attachments: "જોડાણો",
        PoNumber: "પી.ઓ. નંબર",
        SoNumber: "એસ.ઓ. નંબર",
        partner: "પાર્ટનર",
        EditPurchase: "ખરીદી સંપાદિત કરો",
        EditSales: "વેચાણ સંપાદિત કરો",
        PurchaseOrderDetails: "ખરીદી ઓર્ડરની વિગતો",
        SalesOrderDetails: "વેચાણ ઓર્ડરની વિગતો",
        OrderType: "ઓર્ડરનો પ્રકાર",
        SelectOrderType: "ઓર્ડરનો પ્રકાર પસંદ કરો",
        OrderTypePrepaid: "પ્રીપેડ",
        OrderTypeCOD: "કેશ ઓન ડિલિવરી",
        OrderTypePayLater: "પછીથી ચૂકવણી કરો",
        OrderTypePartialPayment: "આંશિક ચુકવણી",
        OrderTypeSubscription: "સબ્સ્ક્રિપ્શન",
        NotReceived: "પ્રાપ્ત નથી",
        NotShipped: "મોકલ્યું નથી",
        PartiallyReceived: "આંશિક રીતે પ્રાપ્ત",
        PartiallyShipped: "આંશિક રીતે મોકલેલ",
    },
    PriceReference: {
        HighPrice: "ઉચ્ચ કિંમત",
        LowPrice: "નીચી કિંમત",
        LastPrice: "છેલ્લી કિંમત",
        LastPurchasePrice: "છેલ્લી ખરીદી કિંમત",
        Nopricerecordsfound: "કોઈ કિંમત રેકોર્ડ મળ્યા નથી",
        BuyingPriceReference: "ખરીદી કિંમતનો સંદર્ભ",
        SellingPriceReference: "વેચાણ કિંમતનો સંદર્ભ",
        Viewstockinpricesfortheselectedvendorandproduct: "પસંદ કરેલ વિક્રેતા અને ઉત્પાદન માટે સ્ટોક-ઇન કિંમતો જુઓ",
        Viewstockoutpricesfortheselectedcustomerandproduct: "પસંદ કરેલ ગ્રાહક અને ઉત્પાદન માટે સ્ટોક-આઉટ કિંમતો જુઓ"
    },
    SubscriptionLocale: {
        premiumPlan: "પ્રીમિયમ પ્લાન",
        heading: "વ્યવસાયિક નિર્ણયો લો",
        headingHighlight: "ડેટા આધારિત",
        subtitle: "તમારા વ્યવસાયના વિશ્લેષણની પૂર્ણ શક્તિ અનલોક કરો — કોઈ મર્યાદા નહીં, કોઈ સમજૂતી નહીં.",
        choosePlan: "તમારો પ્લાન પસંદ કરો",
        monthly: "માસિક",
        annual: "વાર્ષિક",
        oneTime: "એક પ્રયાસ (માસ)",
        perMonth: "પ્રતિ મહિને",
        perYear: "પ્રતિ વર્ષે",
        bestValue: "શ્રેષ્ઠ મૂલ્ય",
        continueWith: "સાથે ચાલુ રાખો",
        perMonthShort: "મહિનો",
        perYearShort: "વર્ષ",
        troubleWithSubscription: "સબસ્ક્રિપ્શનમાં સમસ્યા છે?",
        contactUs: "અમારો સંપર્ક કરો",
        paymentNotReady: "પેમેન્ટ તૈયાર નથી",
        checkoutError: "ચેકઆઉટ ભૂલ",
        pricePreviewError: "કિંમત પૂર્વદર્શન ભૂલ",
        subNotAvailable: "સબ્સ્ક્રિપ્શન ઉપલબ્ધ નથી",
        subNotAvailableDesc: "વેબ સબ્સ્ક્રિપ્શન હાલમાં તમારા દેશમાં ઉપલબ્ધ નથી. કૃપા કરીને અમારી મોબાઇલ એપ દ્વારા સબ્સ્ક્રાઇબ કરો અથવા મદદ માટે અમારો સંપર્ક કરો."
    },
    SubscriptionLocale2: {
        GoPro: "પ્રો પર જાઓ",
        Makesmarterdecisionsbackedbyrealbusinessdata: "વાસ્તવિક વ્યવસાયિક ડેટા દ્વારા સમર્થિત વધુ સ્માર્ટ નિર્ણયો લો",
        ExploreProPlans: "પ્રો પ્લાન્સનું અન્વેષણ કરો"
    },
    emptyWarehouseState: {
        tips: [
            "તમે વિવિધ ભૌતિક સ્થાનો માટે બહુવિધ વેરહાઉસ રાખી શકો છો",
            "દરેક પ્રોડક્ટ વેરહાઉસ પ્રમાણે સ્ટોક સ્વતંત્ર રીતે ટ્રેક કરે છે",
            '"વેરહાઉસ ટ્રાન્સફર" વાપરીને સ્ટોકને એક સ્થાનથી બીજા સ્થાને ખસેડો'
        ],
        NoWarehousesConfigured: "કોઈ વેરહાઉસ કોન્ફિગર કરેલ નથી",
        desc: "પ્રથમ તમારા વેરહાઉસ ઉમેરો (જો એકથી વધુ હોય), પછી પ્રોડક્ટ્સ ઉમેરો અને સ્ટોક મૂવમેન્ટ્સ રેકોર્ડ કરો.",
        WarehouseSetupTips: "વેરહાઉસ સેટઅપ ટિપ્સ",
        Noproductselected: "કોઈ પ્રોડક્ટ પસંદ કરેલ નથી",
        Selectaproductfromthelefttoviewlowstockdetails: "નીચા સ્ટોકની વિગતો જોવા માટે ડાબી બાજુથી એક પ્રોડક્ટ પસંદ કરો.",
        Chooseaproductfromthelist: "લિસ્ટમાંથી એક પ્રોડક્ટ પસંદ કરો",
        SelectProduct: "પ્રોડક્ટ પસંદ કરો",
        SetQuantity: "જથ્થો સેટ કરો",
        Showing: "દર્શાવી રહ્યું છે",
        products: "પ્રોડક્ટ્સ",
        Continue: "ચાલુ રાખો",
        SaveSafetyStock: "સેફ્ટી સ્ટોક સેવ કરો",
        SafetyStockSaved: "સેફ્ટી સ્ટોક સેવ થયો!",
        hasbeensetto: "સેટ કરવામાં આવ્યો છે",
        AddAnother: "બીજું ઉમેરો",
        Chooseaproduct: "એક પ્રોડક્ટ પસંદ કરો",
        Step: "સ્ટેપ",
        of: "નું",
        Setsafetyquantity: "સેફ્ટી જથ્થો સેટ કરો",
        Complete: "પૂર્ણ",
        SafetyStockQuantity: "સેફ્ટી સ્ટોક જથ્થો",
        Minimumunitsdropsbelowthisnumber: "સ્ટોકમાં હંમેશા રાખવાની ન્યૂનતમ યુનિટ્સ. આ સંખ્યા કરતાં નીચે સ્ટોક ગયે એલર્ટ આવે છે.",
        NewSafetyStock: "નવો સેફ્ટી સ્ટોક",
        SafetyNow: "સેફ્ટી હવે",
        SettingTo: "સેટ કરી રહ્યા છીએ",
        Change: "બદલો",
        sell: "વેચાણ",
        cost: "કિંમત",
        BulUD: "બલ્ક અપલોડ/ડિલીટ"
    },
    SimplyLoginUI: {
        sslEncryption: "૨૫૬-બિટ SSL એન્ક્રિપ્શન",
        dataPrivate: "તમારો ડેટા ૧૦૦% ખાનગી છે",
        worksOnDevices: "Android અને iPhone પર કામ કરે છે",
        realTimeSync: "તમામ ડિવાઇસ પર રીયલ-ટાઇમ સિંક",
        cloudBackup: "ઓટોમેટિક ક્લાઉડ બેકઅપ",
        availableOn: "વેબ, Android અને iOS પર ઉપલબ્ધ",
        tagline: "તમારું ઇન્વેન્ટરી,",
        taglineEm: "સુંદર રીતે સરળ.",
        subtitle: "સ્ટોક મેનેજ કરવા, વેચાણ ટ્રેક કરવા અને તમારા વ્યવસાયને આગળ વધારવા માટે સાઇન ઇન કરો — બધું એક જ જગ્યાએ.",
        feature1Title: "રીયલ-ટાઇમ સ્ટોક ટ્રેકિંગ",
        feature1Desc: "દરેક વેરહાઉસમાં શું છે તે ચોક્કસ જાણો, હંમેશા અપડેટ.",
        feature2Title: "વેચાણ અને ખરીદી ઓર્ડર",
        feature2Desc: "ઇન્વૉઇસ બનાવો, વિક્રેતાઓનું સંચાલન કરો અને દરેક ટ્રાન્ઝેક્શન ટ્રેક કરો.",
        feature3Title: "સ્માર્ટ રિપોર્ટ્સ",
        feature3Desc: "ફાઇનાન્સ, સ્ટોક અને દૈનિક મૂવમેન્ટ રિપોર્ટ્સ એક નજરમાં.",
        feature4Title: "તમામ ડિવાઇસ પર રીયલ-ટાઇમ સિંક",
        feature4Desc: "ફોન પર કરેલા ફેરફારો વેબ પર તરત જ દેખાય છે — અને વિપરીત પણ.",
        rating1: "રેટિંગ",
        rating2: "4.9/5",
        rating3: "10,000 પાઇકારી વ્યવસાયો દ્વારા",
        brandName: "Simply",
        greeting: "ફરીથી હેલ્લો! 👋",
        noPasswordNeeded: "તમારા ઇન્વેન્ટરીને ઍક્સેસ કરવા સાઇન ઇન કરો — Android, iPhone અને વેબ, બધું સિંકમાં.",
        badge1: "સ્ટોક મેનેજમેન્ટ",
        badge2: "વેચાણ ટ્રેકિંગ",
        badge3: "રિપોર્ટ્સ",
        trustEncryptedTitle: "એન્ક્રિપ્ટેડ",
        trustEncryptedSub: "256-બિટ SSL",
        trustPrivateTitle: "ખાનગી",
        trustPrivateSub: "માત્ર તમારો ડેટા",
        trustBackedTitle: "બેકઅપ",
        trustBackedSub: "રોજ ઓટો",
        availableOnLabel: "ઉપલબ્ધ છે",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "વેબ",
        syncBadge: "તમામ ડિવાઇસ રીયલ-ટાઇમમાં તરત જ સિંક થાય છે",
        securityNote: "100% સુરક્ષિત.",
        securityDesc: "બેંક-ગ્રેડ એન્ક્રિપ્શન તમારા તમામ ડેટાનું રક્ષણ કરે છે. અમે માત્ર તમારું નામ અને ઇમેઇલ વાંચીએ છીએ — બીજું કંઈ નહીં, ક્યારેય.",
        signingIn: "સાઇન ઇન કરી રહ્યા છીએ…",
        termsPrefix: "સાઇન ઇન કરવાથી તમે Simplyની",
        privacyPolicy: "પ્રાઇવસી પોલિસી",
        and: "અને",
        termsOfService: "સર્વિસની શરતો",
        google: "Google થી લોગિન કરો"
    },
    BatchLocal: {
        BatchName: "બેચનું નામ",
        EnterBatchName: "બેચનું નામ દાખલ કરો",
        EnterNotes: "નોંધ દાખલ કરો",
        ExpiredDate: "સમાપ્તિ તારીખ",
        Selectexpireddate: "સમાપ્તિ તારીખ પસંદ કરો",
        BatchStatus: "બેચની સ્થિતિ",
        CreatedDate: "બનાવવાની તારીખ",
        Areyousureyouwanttodeletethisbatch: "શું તમે ખરેખર આ બેચ કાઢી નાખવા માંગો છો?",
        Youhavencreatedanybatchforthisproduct: "તમે આ પ્રોડક્ટ માટે હજુ કોઈ બેચ બનાવી નથી.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "પ્રથમ બેચ બનાવો જેથી લોટ અને સમાપ્તિ તારીખ અનુસાર સ્ટોક ટ્રેક કરી શકો.",
        Nobatchesyet: "હજુ કોઈ બેચ નથી",
        Whatisbatchmanagement: "બેચ મેનેજમેન્ટ શું છે?",
        Howithelpsyourbusiness: "તે તમારા વ્યવસાયને કેવી રીતે મદદ કરે છે",
        Trackbylotnumber: "લોટ નંબર અનુસાર ટ્રેક કરો",
        Trackbylotnumberdesc: "મેન્યુફેક્ચરરની બેચ અનુસાર સ્ટોકને ગ્રુપ કરો જેથી તમે હંમેશા જાણી શકો કે કયા લોટમાંથી યુનિટ આવી છે.",
        Expirydatecontrol: "સમાપ્તિ તારીખ નિયંત્રણ",
        Expirydatecontroldesc: "સ્ટોક સમાપ્ત થાય તે પહેલાં એલર્ટ મેળવો. જૂની બેચ પહેલાં વેચો અને વેસ્ટ સ્વયંસ્ફુર્ત ઘટાડો.",
        Fulltraceability: "પૂર્ણ ટ્રેસેબિલિટી",
        Fulltraceabilitydesc: "દરેક લેનદેનમાં કઈ બેચ વપરાઈ છે તે જુઓ — ઓડિટ અને રિકોલ માટે ઉત્તમ.",
        Supplierwisestock: "સપ્લાયર અનુસાર સ્ટોક",
        Supplierwisestockdesc: "એક જ પ્રોડક્ટ માટે પણ અલગ અલગ સપ્લાયરનો સ્ટોક અલગ રાખો. બેચ દ્વારા ગુણવત્તા તુલના કરો.",
        Createyourfirstbatchbutton: "તમારી પ્રથમ બેચ બનાવો",
        Nomatchesfound: "કોઈ મેચ મળી નથી",
        NomatchesfounddescBefore: "",
        NomatchesfounddescAfter: " સાથે મેળ ખાતી કોઈ બેચ મળી નથી.",
        Clearsearch: "સર્ચ સાફ કરો",
        Nohistoryfoundthisbatch: "આ બેચ માટે કોઈ ઇતિહાસ મળ્યો નથી",
        ComprehensiveDetails: "વ્યાપક વિગતો",
        History: "ઇતિહાસ",
        InBatch: "બેચમાં",
        Noproductfoundinthisbatch: "આ બેચમાં કોઈ પ્રોડક્ટ મળી નથી",
        SelectBatch: "બેચ પસંદ કરો",
        available: "ઉપલબ્ધ",
        Searchbatches: "બેચ શોધો...",
        Expires: "સમાપ્ત થાય છે",
        Nobatchesfound: "કોઈ બેચ મળી નથી",
        ManageBatches: "બેચનું સંચાલન કરો",
        Batchmanagement: "બેચ મેનેજમેન્ટ",
        Trackstockexpiry: "બેચ અને સમાપ્તિ તારીખ અનુસાર સ્ટોક ટ્રેક કરો",
        Turnoffbatchmanagement: "બેચ મેનેજમેન્ટ બંધ કરવું છે?",
        Yourgsafe: "તમારો હાલનો બેચ ડેટા સુરક્ષિત રહેશે.",
        Reenableanytimefrom: "કોઈપણ સમયે ફરીથી સક્રિય કરી શકો છો",
        Otherstab: "અન્ય ટેબમાંથી",
        AddBatch: "બેચ ઉમેરો",
        Total: "કુલ",
        AssignProduct: "પ્રોડક્ટ અસાઇન કરો",
        EditProductAssignment: "પ્રોડક્ટ અસાઇનમેન્ટ સંપાદિત કરો",
        AssignProducttoBatch: "પ્રોડક્ટને બેચમાં અસાઇન કરો",
        Updateproductconfiguration: "પ્રોડક્ટ કોન્ફિગ્યુરેશન અપડેટ કરો",
        Step1of2: "સ્ટેપ 1 ઓફ 2",
        Step2of2: "સ્ટેપ 2 ઓફ 2",
        Selectvariantwarehouse: "વેરિઅન્ટ અને વેરહાઉસ પસંદ કરો",
        SelectedProduct: "પસંદ કરેલ પ્રોડક્ટ",
        AssignQuantity: "જથ્થો અસાઇન કરો",
        BatchInfo: "બેચની માહિતી",
        Wecouldnthisproductidentifier: "આ પ્રોડક્ટ આઈડેન્ટિફાયર સાથે સંકળાયેલ કોઈ બેચ મળી નથી.",
        NoActiveBatches: "કોઈ સક્રિય બેચ નથી",
        Endofresults: "પરિણામોનો અંત",
        Expiry: "સમાપ્તિ",
        BatchManagementDescription: "બેચ નંબર અને સમાપ્તિ તારીખ દ્વારા સ્ટોક ટ્રૅક કરો. દરેક સ્ટોક-આઉટ પર સાચો LIFO / FEFO ક્રમ સુનિશ્ચિત કરે છે — કોઈ મેન્યુઅલ પસંદગીની જરૂર નથી.",
        Expiryalerts: "સમાપ્તિ ચેતવણીઓ",
        Autonotifications: "સ્વચાલિત સૂચનાઓ",
        LIFOsorting: "LIFO / FEFO સોર્ટિંગ",
        Smartstockflow: "સ્માર્ટ સ્ટોક ફ્લો",
        Perout: "બેચ દીઠ સ્ટોક-આઉટ",
        Precisiontracking: "ચોકસાઇ ટ્રેકિંગ"
    },
    CategoryNewL: {
        TotalCategories: "કુલ કેટેગરી",
        lastaddedcategory: "છેલ્લી ઉમેરેલી કેટેગરી",
        acrossalltypes: "બધા પ્રકારોમાં",
        MostRecent: "સૌથી તાજેતરનું",
        YesD: "હા, કાઢી નાખો",
        AllAssociated: "તમામ સંકળાયેલા પ્રોડક્ટ્સ અસરગ્રસ્ત થઈ શકે છે"
    },
    OverDas: {
        movestockbetweenlocations: "સ્ટોક ખસેડો",
        no_activity_yet: "હજુ કોઈ પ્રવૃત્તિ નથી",
        no_activity_sub: "વેચાણ, ખરીદી, સ્ટોક મૂવમેન્ટ અને રિટર્ન અહીં રીયલ ટાઇમમાં દેખાશે.",
        make_first_sale: "પ્રથમ વેચાણ કરો",
        add_stock: "સ્ટોક ઉમેરો",
        all_stock_healthy: "બધા સ્ટોક લેવલ સ્વસ્થ છે",
        all_stock_healthy_sub: "કોઈ આઇટમ ઓછી પડી નથી. અહીં એલર્ટ મેળવવા માટે પ્રોડક્ટ પર ન્યૂનતમ મર્યાદા સેટ કરો.",
        set_stock_thresholds: "સ્ટોક થ્રેશહોલ્ડ સેટ કરો",
        no_warehouses_setup: "કોઈ વેરહાઉસ સેટઅપ કરેલું નથી",
        no_warehouses_setup_sub: "તમારો સ્ટોક ક્યાં સંગ્રહિત છે તે ટ્રેક કરવા અને લોકેશન મેનેજ કરવા માટે એક વેરહાઉસ ઉમેરો.",
        add_first_warehouse: "પ્રથમ વેરહાઉસ ઉમેરો",
        Customer: "ગ્રાહકો",
        PurchasevsSales: "ખરીદી વિરુદ્ધ વેચાણ",
        Financialperformancechart: "નાણાકીય પ્રદર્શન ચાર્ટ",
        QuickActions: "ઝડપી ક્રિયાઓ",
        Frequentlyused: "વારંવાર વપરાતું",
        Addinventory: "ઇન્વેન્ટરી ઉમેરો",
        Dispatchitems: "આઇટમ્સ મોકલો",
        Addorder: "ઓર્ડર ઉમેરો",
        Newitem: "નવી આઇટમ",
        Inventoryaccess: "ઇન્વેન્ટરી ઍક્સેસ",
        Itemsneedingreorder: "રીઓર્ડર જરૂરી આઇટમ્સ",
        Latesttransactions: "તાજેતરના વ્યવહારો",
        Operationalsummary: "ઓપરેશનલ સારાંશ",
        ViewAll: "બધું જુઓ",
        Manage: "મેનેજ કરો",
        RecentActivity: "તાજેતરની પ્રવૃત્તિ",
        LowStockAlerts: "નીચા સ્ટોકની ચેતવણી",
        Primary: "પ્રાથમિક",
        TotalWarehouses: "કુલ વેરહાઉસ"
    },
    SerialLocal: {
        Manufacturesettings: "ઉત્પાદન સેટિંગ્સ",
        Showbuyingprice: "ખરીદ કિંમત / ઉત્પાદન ખર્ચ દર્શાવો",
        Showadditionalcost: "વધારાની કિંમત દર્શાવો",
        Costbreakdown: "ખર્ચ વિગતો",
        Unitcost: "એકમ દીઠ ખર્ચ",
        Rawmaterialstotal: "કુલ કાચો માલ",
        Confirmentry: "એન્ટ્રી કન્ફર્મ કરો",
        SaveSerials: "સિરિયલ નંબર સેવ કરો",
        SerialNumber: "સિરિયલ નંબર",
        selected: "પસંદ કરેલ",
        added: "ઉમેર્યું",
        Serialnumbers: "સિરિયલ નંબર્સ",
        ResetAll: "બધું રીસેટ કરો",
        Wecouldnfindthis: "આ પ્રોડક્ટ માટે કોઈ ઉપલબ્ધ સિરિયલ નંબર મળ્યા નથી.",
        Nounitsfound: "કોઈ યુનિટ મળ્યા નથી",
        Searchingserialnumbers: "સિરિયલ નંબર્સ શોધી રહ્યા છીએ...",
        Scanorenterstock: "નવા સ્ટોક માટે સિરિયલ સ્કેન કરો અથવા દાખલ કરો",
        Whataserialnumber: "સિરિયલ નંબર શું છે?",
        Auniqueidentifieryourinventorylifecycle: "દરેક યુનિટ માટે અનન્ય આઈડેન્ટિફાયર — તમને તમારા ઇન્વેન્ટરી લાઇફસાઇકલમાં દરેક આઇટમને ટ્રેક કરવા દે છે.",
        Trackedstockout: "ટ્રેક કરેલ સ્ટોક આઉટ",
        Chooseexactlyselected: "ચોક્કસ પસંદ કરો કે કયા સીરીયલ નંબર્સ બહાર જઈ રહ્યા છે. માત્ર આ પ્રોડક્ટ માટે સ્ટોક કરેલ સીરીયલ્સ જ દેખાય છે — તમે પસંદ કર્યા પછી જથ્થો લોક થઈ જાય છે ",
        SelectSerialstoout: " - બહાર મોકલવા માટે સિરિયલ પસંદ કરો",
        Thisinvoicegeneratedusingwwwsimplstockco: "આ ઇન્વોઇસ www.simplstock.co વાપરીને તૈયાર કરવામાં આવી છે",
        AuthorizedSignature: "અધિકૃત સહી",
        Invoicesettings: "ઇન્વોઇસ સેટિંગ્સ",
        Draw: "દોરો",
        Taptoselectordeselectitems: "આઇટમ પસંદ અથવા અનપસંદ કરવા માટે ટેપ કરો",
        Thissignaturewillbeadded: "આ સહી તમારા પ્રિન્ટેડ ઇન્વોઇસના તળિયે ઉમેરવામાં આવશે.",
        SignatureOptions: "સહી વિકલ્પો",
        Upload: "અપલોડ",
        DrawSignature: "સહી દોરો",
        UploadSignature: "સહી અપલોડ કરો",
        Clear: "સાફ કરો",
        ShowStaffName: "સ્ટાફનું નામ બતાવો",
        ShowSKU: "SKU બતાવો",
        ShowBusinessName: "બિઝનેસનું નામ બતાવો",
        ShowProductName: "પ્રોડક્ટનું નામ બતાવો",
        ShowBusinessPhoneNumber: "વ્યવસાયનો ફોન નંબર બતાવો",
        ShowBusinessEmail: "વ્યવસાયની ઈમેઈલ બતાવો",
        ShowBusinessAddress: "વ્યવસાયનું સરનામું બતાવો",
        ShowProductImage: "ઉત્પાદની છબી બતાવો",
        ShowPaymentDetails: "ચુકવણીની વિગતો બતાવો",
        ShowCategory: "કેટેગરી બતાવો",
        ShowVariant: "વેરિઅન્ટ બતાવો",
        ShowWarehouse: "વેરહાઉસ બતાવો",
        ShowAttributes: "એટ્રિબ્યુટ્સ બતાવો",
        ShowQuantity: "જથ્થો બતાવો",
        ShowDiscount: "ડિસ્કાઉન્ટ બતાવો",
        ShowTax: "ટેક્સ બતાવો",
        ShowPrice: "ભાવ બતાવો",
        ShowTotalPrice: "ઉત્પાદનનો કુલ ભાવ બતાવો",
        ShowExpenses: "ખર્ચ બતાવો",
        ShowSignature: "સહી બતાવો",
        ShowNote: "નોંધ બતાવો",
        showAttachment: "જોડાણ બતાવો",
        ShowSerialNumber: "સિરિયલ નંબર બતાવો",
        Invoicesettingsapplied: "ઇન્વોઇસ સેટિંગ્સ લાગુ કરવામાં આવી છે. ફેરફારો માટે ઇન્વોઇસ તપાસો.",
        EnterSerialNumber: "સિરિયલ નંબર દાખલ કરો",
    },
    FewLocal: {
        SelectBin: "બિન પસંદ કરો",
        Live: "લાઇવ",
        Monitorinventorystocklevels: "ઇન્વેન્ટરી, મૂવમેન્ટ અને સ્ટોક લેવલ મોનિટર કરો",
        StockControlCentre: "સ્ટોક કંટ્રોલ સેન્ટર",
        Nochartdataavailable: "કોઈ ચાર્ટ ડેટા ઉપલબ્ધ નથી",
        Disabled: "અક્ષમ",
        Enabled: "સક્ષમ"
    },
    Bin: {
        Bin: "બિન",
        Add: "ઉમેરો",
        NoBinsAddedYet: "હજુ કોઈ બિન ઉમેર્યા નથી",
        BinLocationsHelp: "બિન લોકેશન તમને આ વેરહાઉસની અંદર સચોટ સ્થાન અનુસાર સ્ટોક ટ્રેક કરવામાં મદદ કરે છે — હવે શોધવાની જરૂર નથી.",
        NameThemByPosition: "સ્થાન અનુસાર નામ આપો:",
        AddBinLocation: "બિન લોકેશન ઉમેરો",
        BinLocations: "બિન લોકેશન",
        BinNameRequired: "બિનનું નામ જરૂરી છે",
        EditBin: "બિન સંપાદિત કરો",
        AddBin: "બિન ઉમેરો",
        EnterBinName: "બિનનું નામ",
        EnterBinNamePlaceholder: "બિનનું નામ દાખલ કરો",
        BinStatus: "બિનની સ્થિતિ",
        BinNotes: "નોંધ",
        EnterBinNotesPlaceholder: "કેટલીક નોંધ ઉમેરો...",
        ViewInventory: "ઇન્વેન્ટરી જુઓ",
        Inventory: "ઇન્વેન્ટરી",
        TrymatchingadifferentSKUname: "અલગ SKU અથવા નામથી પ્રયાસ કરો.",
        Thisbinlocationcurrentlyempty: "આ બિન લોકેશન હાલમાં ખાલી છે.",
        Loadingbins: "બિન લોડ થઈ રહ્યા છે...",
        bins: "બિન",
        ManageBin: "બિન મેનેજ કરો",
        Print: "પ્રિન્ટ",
        SBin: "સોર્સ બિન",
        DBin: "ડેસ્ટિનેશન બિન"
    },
    WarehouseExcel: {
        title: "વેરહાઉસ અને બિન લોકેશન અપલોડ કરો",
        description: "નીચેના સ્ટેપ્સ અનુસરીને Excel ફાઇલ દ્વારા બલ્કમાં વેરહાઉસ અને તેના બિન લોકેશન બનાવો.",
        bulkUploadGuide: "બલ્ક અપલોડ ગાઇડ",
        step1: "સ્ટેપ 1",
        downloadTemplate: "Excel ટેમ્પ્લેટ ડાઉનલોડ કરો",
        downloadTemplateDesc: "બધા જરૂરી કોલમ હેડર સાથેનું ઓફિશિયલ ટેમ્પ્લેટ ડાઉનલોડ કરો. કોઈ કોલમનું નામ બદલશો નહીં અથવા દૂર કરશો નહીં.",
        downloadTemplateBtn: "ટેમ્પ્લેટ ડાઉનલોડ કરો",
        step2: "સ્ટેપ 2",
        fillExcelFile: "Excel ફાઇલ ભરો",
        fillExcelDesc: "દરેક રો એક વેરહાઉસનું પ્રતિનિધિત્વ કરે છે. બધા કોલમ ભરો — બિન લોકેશન માટે <code>Bin Names</code> કોલમમાં બધા બિનના નામ કોમા વડે લખો.",
        step3: "સ્ટેપ 3",
        thingsToKeepInMind: "ધ્યાનમાં રાખવાની બાબતો",
        rulesDesc: "અપલોડ કરતા પહેલા ખાતરી કરો કે તમારી ફાઇલ આ નિયમોનું પાલન કરે છે.",
        step4: "સ્ટેપ 4",
        uploadYourFile: "તમારી ફાઇલ અપલોડ કરો",
        uploadDesc: "ભર્યા પછી નીચે ફાઇલ અપલોડ કરો. સિસ્ટમ આપોઆપ બધા વેરહાઉસ અને બિન લોકેશન બનાવશે.",
        rules: ["દરેક વેરહાઉસ માટે માત્ર એક રો", "એક સેલમાં કોમા વડે બિન નામો", "કોલમ હેડરનું નામ ના બદલવું", "એક જ વેરહાઉસમાં ડુપ્લિકેટ બિન નામ છોડી દેવામાં આવે છે", "દેશ કોડ સાથે ફોન નંબર", "માત્ર .xlsx અથવા .xls ફાઇલો સ્વીકાર્ય"],
        dropFileHere: "તમારી Excel ફાઇલ અહીં ડ્રોપ કરો",
        supports: "સપોર્ટ કરે છે .xlsx અને .xls — મહત્તમ 10 MB",
        chooseFileUpload: "ફાઇલ પસંદ કરો અને અપલોડ કરો",
        parsing: "ફાઇલ પાર્સ કરી રહ્યું છે...",
        invalidFileType: "અમાન્ય ફાઇલ પ્રકાર. કૃપા કરીને Excel ફાઇલ અપલોડ કરો.",
        noData: "Excel માં કોઈ ડેટા મળ્યો નથી",
        failedToRead: "Excel ફાઇલ વાંચવામાં નિષ્ફળ",
        unableToRead: "ફાઇલ વાંચી શકાઈ નહીં.",
        reviewTitle: "વેરહાઉસ ડેટાની સમીક્ષા",
        reviewSubtitle: "તમારા બિઝનેસમાં આયાત કરતા પહેલા અંતિમ તપાસ.",
        changeFile: "ફાઇલ બદલો",
        rowsFound: "રો મળી",
        cancel: "રદ કરો",
        finalizeImport: "ફાઇનલ કરો અને આયાત કરો",
        importing: "આયાત થઈ રહી છે...",
        success: "સફળ",
        allWarehouseUploadedSuccess: "બધા વેરહાઉસ સફળતાપૂર્વક અપલોડ થયા",
        failed: "નિષ્ફળ",
        bulkUploadFailed: "બલ્ક અપલોડ નિષ્ફળ",
        error: "ભૂલ",
        binNamesNote: "<strong>Bin Names</strong> કોલમમાં એક જ સેલમાં બધા બિન લોકેશન કોમા વડે લખો — ઉદા. A1, A2, B1, RACK-01.",
        headers: { warehouseName: "વેરહાઉસનું નામ", email: "ઈમેલ", phoneNumber: "ફોન નંબર", location: "સ્થાન", binNames: "બિન નામો" }
    },
    VariantTemplate: {
        VariantTemplates: "વેરિઅન્ટ ટેમ્પ્લેટ્સ",
        Managereusablevariantpatterns: "પુન:ઉપયોગી વેરિઅન્ટ પેટર્ન્સ મેનેજ કરો",
        BinTransferHistory: "બિન ટ્રાન્સફર હિસ્ટ્રી",
        Trackmovementsacrossbins: "બિન વચ્ચે મૂવમેન્ટ્સ ટ્રેક કરો",
        SerialNumberHistory: "સીરિયલ નંબર હિસ્ટ્રી",
        Trackproductserialnumberactivity: "પ્રોડક્ટ સીરિયલ નંબરની પ્રવૃત્તિ ટ્રેક કરો",
        Period: "સમયગાળો",
        Nohistoryfound: "કોઈ હિસ્ટ્રી મળી નથી",
        Searchserialnumbers: "સીરિયલ નંબર્સ શોધો...",
        SerialNumbersHistory: "સીરિયલ નંબર્સ હિસ્ટ્રી",
        Serialnumberhistoryglance: "સીરિયલ નંબર હિસ્ટ્રી એક નજરમાં.",
        Noserialnumbersfound: "કોઈ સીરિયલ નંબર મળ્યા નથી",
        Noactivityhistoryfound: "કોઈ પ્રવૃત્તિ હિસ્ટ્રી મળી નથી",
        Statussetto: "સ્ટેટસ સેટ કર્યું",
        Timeline: "ટાઇમલાઇન",
        Managereusableproductvariantpatterns: "પુન:ઉપયોગી પ્રોડક્ટ વેરિઅન્ટ પેટર્ન્સ મેનેજ કરો.",
        DeleteTemplate: "ટેમ્પ્લેટ કાઢી નાખો",
        Areyousureyouwanttemplate: "શું તમે આ ટેમ્પ્લેટ કાઢી નાખવા માંગો છો?",
        CreateNewTemplate: "નવું ટેમ્પ્લેટ બનાવો",
        CreateTemplate: "ટેમ્પ્લેટ બનાવો",
        EditTemplate: "ટેમ્પ્લેટ સંપાદિત કરો",
        UnlimitedTemplates: "અમર્યાદિત ટેમ્પ્લેટ્સ",
        CreateAsManyTemplates: "જેટલા જોઈએ તેટલા ટેમ્પ્લેટ્સ બનાવો — કપડાં, જૂતાં, ઇલેક્ટ્રોનિક્સ અને વધુ.",
        PickWhileAddingProduct: "પ્રોડક્ટ ઉમેરતી વખતે પસંદ કરો",
        OpenTemplateLibrary: "તમારી ટેમ્પ્લેટ લાઇબ્રેરી ખોલો અને સેકન્ડમાં વેરિઅન્ટ નામો પસંદ કરો.",
        MixFromMultipleTemplates: "બહુવિધ ટેમ્પ્લેટ્સમાંથી મિક્સ કરો",
        SelectFromMultipleTemplates: "એક પ્રોડક્ટ માટે એક કરતાં વધુ ટેમ્પ્લેટ્સમાંથી વેરિઅન્ટ નામો પસંદ કરો — પૂર્ણપણે લવચીક.",
        EditAnytime: "કોઈપણ સમયે સંપાદિત કરો",
        RenameTemplatesAnytime: "ટેમ્પ્લેટ્સનું નામ બદલો, વેરિઅન્ટ નામો ઉમેરો અથવા દૂર કરો જ્યારે તમારો કેટલોગ બદલાય.",
        StayConsistent: "સુસંગત રહો",
        SameVariantNamesAcrossAll: "બધા પ્રોડક્ટ્સમાં સમાન વેરિઅન્ટ નામો. કોઈ ટાઇપો, કોઈ ડુપ્લિકેટ, કોઈ અનુમાન નહીં.",
        BuildOnceUseEverywhere: "એક વાર બનાવો, બધે વાપરો",
        StopReEnteringVariantNames: "દરેક પ્રોડક્ટ માટે સમાન વેરિઅન્ટ નામો ફરીથી લખવાનું બંધ કરો. એક ટેમ્પ્લેટ બનાવો, વેરિઅન્ટ નામો આપો અને તરત જ ફરીથી વાપરો.",
        Updateexistingvariantcombinations: "હાલની વેરિઅન્ટ કોમ્બિનેશન અપડેટ કરો",
        Definenewvariantcombinations: "નવી વેરિઅન્ટ કોમ્બિનેશન વ્યાખ્યાયિત કરો",
        TemplateName: "ટેમ્પ્લેટનું નામ",
        AddVariantOptions: "વેરિઅન્ટ વિકલ્પો ઉમેરો",
        SmallMedium: "દા.ત. સ્મોલ, મીડિયમ...",
        VariantsList: "વેરિઅન્ટ્સની લિસ્ટ",
        Nooptionsaddedyet: "હજુ કોઈ વિકલ્પો ઉમેર્યા નથી",
        SaveTemplate: "ટેમ્પ્લેટ સેવ કરો",
        egSizesColorsetc: "દા.ત. ટી-શર્ટ સાઈઝ, કલર્સ, વગેરે.",
        Pleaseentertemplatename: "કૃપા કરીને ટેમ્પ્લેટનું નામ દાખલ કરો",
        Pleaseaddatleastonevariantoption: "કૃપા કરીને ઓછામાં ઓછો એક વેરિઅન્ટ વિકલ્પ ઉમેરો",
        Templateupdatedsuccessfully: "ટેમ્પ્લેટ સફળતાપૂર્વક અપડેટ થયું",
        Templatecreatedsuccessfully: "ટેમ્પ્લેટ સફળતાપૂર્વક બનાવવામાં આવ્યું",
        Failedtosavetemplate: "ટેમ્પ્લેટ સેવ કરવામાં નિષ્ફળ",
        Transfer: "ટ્રાન્સફર",
        Editassignment: "એસાઇનમેન્ટ સંપાદિત કરો",
        Updateproductdetailsinbin: "બિનમાં પ્રોડક્ટ વિગતો અપડેટ કરો",
        Editinginbin: "બિનમાં સંપાદન ચાલુ છે",
        ConfirmUpdate: "અપડેટની પુષ્ટિ કરો",
        ConfirmAssign: "એસાઇનની પુષ્ટિ કરો",
        Assignanotherproduct: "બીજું પ્રોડક્ટ એસાઇન કરો",
        TransferBin: "બિન ટ્રાન્સફર કરો",
        SourceBin: "સોર્સ બિન",
        DestinationBin: "ડેસ્ટિનેશન બિન",
        SelectSourceBin: "સોર્સ બિન પસંદ કરો",
        SelectDestinationBin: "ડેસ્ટિનેશન બિન પસંદ કરો",
        Unit: "યુનિટ",
        ManageVariant: "વેરિઅન્ટ મેનેજ કરો",
        CreateSKUvariationsyourproduct: "તમારા પ્રોડક્ટ માટે SKU વેરિએશન્સ બનાવો",
        Assigningvariationsto: "વેરિએશન્સને આપી રહ્યા છીએ",
        Novariantsaddedyet: "હજુ કોઈ વેરિઅન્ટ્સ ઉમેર્યા નથી",
        AddedVariants: "ઉમેરેલા વેરિઅન્ટ્સ",
        AddVariantsfromTemplate: "ટેમ્પ્લેટમાંથી વેરિઅન્ટ્સ ઉમેરો",
        Pickatemplateandselectvariantnames: "ટેમ્પ્લેટ પસંદ કરો અને વેરિઅન્ટ નામો પસંદ કરો",
        ChooseaTemplate: "ટેમ્પ્લેટ પસંદ કરો",
        Selectvariantnamestoadd: "ઉમેરવા માટે વેરિઅન્ટ નામો પસંદ કરો",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "વેરિઅન્ટ નામો પસંદ કરવા માટે ટેમ્પ્લેટ પસંદ કરો. તમે અનેકમાંથી ઉમેરી શકો છો.",
        Loadingtemplates: "ટેમ્પ્લેટ્સ લોડ થઈ રહ્યા છે...",
        Backtotemplates: "ટેમ્પ્લેટ્સ પર પાછા જાઓ",
        Selectallindividualadd: "બધા અથવા વ્યક્તિગત વેરિઅન્ટ નામો પસંદ કરીને ઉમેરો.",
        VariantNames: "વેરિઅન્ટ નામો",
        MediaDescription: "મીડિયા અને વર્ણન",
        Addattachmentsandproductnotes: "જોડાણો અને પ્રોડક્ટ નોંધો ઉમેરો",
        ProductMedia: "પ્રોડક્ટ મીડિયા"
    },
    AddProductGuide: {
        title: "સેવ કર્યા પછી પ્રારંભિક જથ્થો ઉમેરો",
        description: "અહીં પ્રોડક્ટ્સમાં જથ્થાનું ફીલ્ડ નથી. સેવ કર્યા પછી, 'સ્ટોક ઇન' વાપરીને તમારો ઓપનિંગ સ્ટોક લોગ કરો — સ્થાન અને ટ્રેકિંગ પર પૂર્ણ નિયંત્રણ સાથે.",
        steps: {
            quantity: { title: "જથ્થો", sub: "ઓપનિંગ સ્ટોકની સંખ્યા સેટ કરો" },
            binLocation: { title: "બિન લોકેશન", sub: "એસલ, રેક, શેલ્ફ — દા.ત. A-01-03" },
            serialNumbers: { title: "સીરિયલ નંબર", sub: "દરેક યુનિટને વ્યક્તિગત રીતે ટ્રેક કરો" },
            warehouse: { title: "વેરહાઉસ", sub: "કયા સ્થાને સ્ટોર કરેલ છે" },
            batchExpiry: { title: "બેચ / એક્સપાયરી", sub: "બેચ નંબર મુજબ સ્ટોક જૂથ કરો" }
        },
        actions: { close: "બંધ કરો" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "કોઈ ટ્રાન્સફર ઓર્ડર મળ્યા નથી",
        Itemshistory: "જે આઈટમ્સ તમે વેરહાઉસ વચ્ચે ટ્રાન્સફર કરો છો તે ટ્રેકિંગ અને હિસ્ટ્રી માટે અહીં દેખાશે.",
        CreateTransfer: "ટ્રાન્સફર બનાવો"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "ઉત્પાદન માટે પ્રોડક્ટ પર ટેપ કરો",
        Selectproductfrombelow: "નીચેની યાદીમાંથી પ્રોડક્ટ પસંદ કરો",
        SetupANewProduct: "નવી પ્રોડક્ટ સેટ કરો",
        DefineAProductAdditsrawmaterial: "પ્રોડક્ટ વ્યાખ્યાયિત કરો અને તેની કાચી સામગ્રી ઉમેરો",
        ManufacturingSetup: "મેન્યુફેક્ચરિંગ સેટઅપ",
        Pickproducttodefineitsproductiondetails: "ઉત્પાદન વિગતો નક્કી કરવા માટે પ્રોડક્ટ પસંદ કરો",
        ConfigureManufacturing: "મેન્યુફેક્ચરિંગ કોન્ફિગર કરો",
        SelectRawMaterial: "કાચી સામગ્રી પસંદ કરો",
        NoRawMaterials: "કોઈ કાચી સામગ્રી નથી",
        Definecomponentsneededtoproduct: "આ પ્રોડક્ટ બનાવવા માટે જરૂરી ઘટકો નક્કી કરો.",
        NoAdditionalCosts: "કોઈ વધારાના ખર્ચ નથી",
        Addlaboroverheadlogisticalcharges: "મજૂરી, અન્ય ખર્ચ અથવા લોજિસ્ટિકલ ચાર્જ ઉમેરો.",
        AddAdditionalCost: "વધારાના ખર્ચ ઉમેરો",
        AddCost: "ખર્ચ ઉમેરો",
        TotalPrice: "કુલ કિંમત",
        SelectCharges: "ચાર્જ પસંદ કરો",
        EnterEstimatedCost: "અંદાજિત ખર્ચ દાખલ કરો",
        QtyRequried: "જરૂરી જથ્થો",
        Manufacturing: "મેન્યુફેક્ચરિંગ",
        Outputfinishedgoodsdestination: "તૈયાર માલનું ગંતવ્ય",
        Manufacturingquantity: "ઉત્પાદન જથ્થો",
        Storefinishedgoodsat: "તૈયાર માલ અહીં સંગ્રહિત કરો",
        Rawmaterials: "કાચી સામગ્રી",
        StockSelection: "સ્ટોક પસંદગી",
        AdditionalCosts: "વધારાના ખર્ચ",
        Quantityconsume: "વપરાશ જથ્થો",
        Totalmanufacturingcost: "કુલ ઉત્પાદન ખર્ચ",
        Sumofrawmaterialcosts: "તમામ કાચી સામગ્રી ખર્ચનો સરવાળો",
        CustomManufacturingCharge: "કસ્ટમ મેન્યુફેક્ચરિંગ ચાર્જ",
        Addextralikelaboroverheadrepairs: "મજૂરી, ઓવરહેડ અથવા રિપેરિંગ જેવા વધારાના ખર્ચ ઉમેરો.",
        CalculatedTotal: "ગણતરી કરેલ કુલ",
        AddRawMaterial: "કાચી સામગ્રી ઉમેરો",
        ConfigureRawMaterial: "કાચી સામગ્રી કોન્ફિગર કરો",
        Thisoutputunit: "આ દીઠ આઉટપુટ યુનિટ માટે જરૂરી મૂળભૂત જથ્થો છે.",
        ChangeProduct: "પ્રોડક્ટ બદલો",
        AddtoList: "યાદીમાં ઉમેરો",
        ManufacturedSuccessfully: "સફળતાપૂર્વક ઉત્પાદિત થયું",
        Manufacture: "ઉત્પાદન",
        EditDeleteHistory: "એડિટ/ડિલીટ હિસ્ટ્રી",
        ManageOrder: "ઓર્ડર મેનેજ કરો",
        ManageBatch: "બેચ મેનેજ કરો",
        Paymentnotavailablehere: "અહીં ચુકવણી ઉપલબ્ધ નથી",
        Thisrecordisanorderorderitself: "આ રેકોર્ડ ઓર્ડરમાંથી છે. ચુકવણી માત્ર ઓર્ડરમાંથી જ નોંધી શકાય છે.",
        Torecorpaymenttheorderthethere: "ચુકવણી નોંધવા માટે, લિંક કરેલ ઓર્ડર પર જાઓ અને ત્યાં <b>ચુકવણી નોંધો</b> વિકલ્પ વાપરો.",
        GotoOrder: "ઓર્ડર પર જાઓ"
    },
    CustomerExcel: {
        title: "ગ્રાહકો અપલોડ કરો",
        description: "Excel ફાઇલનો ઉપયોગ કરીને જથ્થાબંધ ગ્રાહકો બનાવવા માટે નીચેના પગલાં અનુસરો.",
        bulkUploadGuide: "જથ્થાબંધ અપલોડ માર્ગદર્શિકા",
        step1: "પગલું 1",
        downloadTemplate: "Excel ટેમ્પલેટ ડાઉનલોડ કરો",
        downloadTemplateDesc: "તમામ જરૂરી કૉલમ હેડર્સ સાથે સત્તાવાર ટેમ્પલેટ મેળવો.",
        downloadTemplateBtn: "ટેમ્પલેટ ડાઉનલોડ કરો",
        step2: "પગલું 2",
        fillExcelFile: "Excel ફાઇલ ભરો",
        fillExcelDesc: "દરેક હરોળ એક ગ્રાહકનું પ્રતિનિધિત્વ કરે છે. જરૂર મુજબ તમામ કૉલમ ભરો.",
        step3: "પગલું 3",
        thingsToKeepInMind: "ધ્યાનમાં રાખવાની બાબતો",
        rulesDesc: "અપલોડ કરતા પહેલા, ખાતરી કરો કે તમારી ફાઇલ ભૂલો ટાળવા માટે આ નિયમોનું પાલન કરે છે.",
        step4: "પગલું 4",
        uploadYourFile: "તમારી ફાઇલ અપલોડ કરો",
        uploadDesc: "ભર્યા પછી, નીચે ફાઇલ અપલોડ કરો. સિસ્ટમ આપમેળે તમામ ગ્રાહકો બનાવશે.",
        rules: [
            "ગ્રાહક દીઠ માત્ર એક હરોળ",
            "કૉલમ હેડર્સના નામ બદલશો નહીં",
            "દેશના કોડ સાથે સંપર્ક નંબર",
            "માત્ર .xlsx અથવા .xls ફાઇલો જ સ્વીકારવામાં આવશે"
        ],
        dropFileHere: "તમારી Excel ફાઇલ અહીં મૂકો",
        supports: ".xlsx અને .xls સપોર્ટ કરે છે — મહત્તમ 10 MB",
        chooseFileUpload: "ફાઇલ પસંદ કરો અને અપલોડ કરો",
        parsing: "ફાઇલનું વિશ્લેષણ કરી રહ્યું છે...",
        invalidFileType: "અમાન્ય ફાઇલ પ્રકાર. કૃપા કરીને Excel ફાઇલ અપલોડ કરો.",
        noData: "Excel માં કોઈ ડેટા મળ્યો નથી",
        failedToRead: "Excel ફાઇલ વાંચવામાં નિષ્ફળ",
        unableToRead: "ફાઇલ વાંચવામાં અસમર્થ.",
        reviewTitle: "ગ્રાહક ડેટાની સમીક્ષા કરો",
        reviewSubtitle: "તમારા વ્યવસાયમાં આયાત કરતા પહેલા અંતિમ તપાસ.",
        changeFile: "ફાઇલ બદલો",
        rowsFound: "ફાઇલમાં હરોળ મળી",
        cancel: "રદ કરો",
        finalizeImport: "પૂર્ણ કરો અને આયાત કરો",
        importing: "આયાત કરી રહ્યું છે...",
        success: "સફળ",
        allCustomerUploadedSuccess: "તમામ ગ્રાહકો સફળતાપૂર્વક અપલોડ થયા",
        failed: "નિષ્ફળ",
        bulkUploadFailed: "જથ્થાબંધ અપલોડ નિષ્ફળ",
        error: "ભૂલ",
        headers: {
            customerName: "ગ્રાહકનું નામ",
            phoneNumber: "સંપર્ક",
            address: "સરનામું",
            note: "નોંધ"
        }
    },
    SupplierExcel: {
        title: "વિક્રેતાઓ અપલોડ કરો",
        description: "Excel ફાઇલનો ઉપયોગ કરીને જથ્થાબંધ વિક્રેતાઓ બનાવવા માટે નીચેના પગલાં અનુસરો.",
        bulkUploadGuide: "જથ્થાબંધ અપલોડ માર્ગદર્શિકા",
        step1: "પગલું 1",
        downloadTemplate: "Excel ટેમ્પલેટ ડાઉનલોડ કરો",
        downloadTemplateDesc: "તમામ જરૂરી કૉલમ હેડર્સ સાથે સત્તાવાર ટેમ્પલેટ મેળવો.",
        downloadTemplateBtn: "ટેમ્પલેટ ડાઉનલોડ કરો",
        step2: "પગલું 2",
        fillExcelFile: "Excel ફાઇલ ભરો",
        fillExcelDesc: "દરેક હરોળ એક વિક્રેતાનું પ્રતિનિધિત્વ કરે છે. જરૂર મુજબ તમામ કૉલમ ભરો.",
        step3: "પગલું 3",
        thingsToKeepInMind: "ધ્યાનમાં રાખવાની બાબતો",
        rulesDesc: "અપલોડ કરતા પહેલા, ખાતરી કરો કે તમારી ફાઇલ ભૂલો ટાળવા માટે આ નિયમોનું પાલન કરે છે.",
        step4: "પગલું 4",
        uploadYourFile: "તમારી ફાઇલ અપલોડ કરો",
        uploadDesc: "ભર્યા પછી, નીચે ફાઇલ અપલોડ કરો. સિસ્ટમ આપમેળે તમામ વિક્રેતાઓ બનાવશે.",
        rules: [
            "વિક્રેતા દીઠ માત્ર એક હરોળ",
            "કૉલમ હેડર્સના નામ બદલશો નહીં",
            "દેશના કોડ સાથે સંપર્ક નંબર",
            "માત્ર .xlsx અથવા .xls ફાઇલો જ સ્વીકારવામાં આવશે"
        ],
        dropFileHere: "તમારી Excel ફાઇલ અહીં મૂકો",
        supports: ".xlsx અને .xls સપોર્ટ કરે છે — મહત્તમ 10 MB",
        chooseFileUpload: "ફાઇલ પસંદ કરો અને અપલોડ કરો",
        parsing: "ફાઇલનું વિશ્લેષણ કરી રહ્યું છે...",
        invalidFileType: "અમાન્ય ફાઇલ પ્રકાર. કૃપા કરીને Excel ફાઇલ અપલોડ કરો.",
        noData: "Excel માં કોઈ ડેટા મળ્યો નથી",
        failedToRead: "Excel ફાઇલ વાંચવામાં નિષ્ફળ",
        unableToRead: "ફાઇલ વાંચવામાં અસમર્થ.",
        reviewTitle: "વિક્રેતા ડેટાની સમીક્ષા કરો",
        reviewSubtitle: "તમારા વ્યવસાયમાં આયાત કરતા પહેલા અંતિમ તપાસ.",
        changeFile: "ફાઇલ બદલો",
        rowsFound: "ફાઇલમાં હરોળ મળી",
        cancel: "રદ કરો",
        finalizeImport: "પૂર્ણ કરો અને આયાત કરો",
        importing: "આયાત કરી રહ્યું છે...",
        success: "સફળ",
        allSupplierUploadedSuccess: "તમામ વિક્રેતાઓ સફળતાપૂર્વક અપલોડ થયા",
        failed: "નિષ્ફળ",
        bulkUploadFailed: "જથ્થાબંધ અપલોડ નિષ્ફળ",
        error: "ભૂલ",
        headers: {
            supplierName: "વિક્રેતાનું નામ",
            phoneNumber: "સંપર્ક",
            bankName: "બેંકનું નામ",
            accountHolderName: "ખાતાધારકનું નામ",
            accountNumber: "એકાઉન્ટ નંબર",
            note: "નોંધ"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "સાથે બદલવામાં આવ્યું",
        Noreplacementhistoryfound: "કોઈ બદલી ઇતિહાસ મળ્યો નથી",
        Noreturnhistoryfound: "કોઈ પરત ઇતિહાસ મળ્યો નથી",
        Productbeingreturned: "ઉત્પાદન પરત કરવામાં આવી રહ્યું છે",
        Required: "જરૂરી",
        Selectreturnedproduct: "પરત કરેલ ઉત્પાદન પસંદ કરો",
        Searchnamescanbarcode: "નામ, SKU દ્વારા શોધો અથવા બારકોડ સ્કેન કરો",
        Browse: "બ્રાઉઝ કરો",
        Stockhandling: "સ્ટોક-ઇન હેન્ડલિંગ",
        Stockinreturnedproduct: "પરત કરેલ ઉત્પાદન સ્ટોક ઇન કરો",
        Ontoinventory: "ચાલુ — પરત કરેલી આઇટમ ફરીથી ઇન્વેન્ટરીમાં ઉમેરવામાં આવશે",
        Offreturnedonly: "બંધ — આઇટમ ફક્ત પરત કરેલ તરીકે નોંધવામાં આવશે",
        Usedrestock: "પુન: સ્ટોક કરતી વખતે નફાના એડજસ્ટમેન્ટની ગણતરી કરવા માટે વપરાય છે",
        Willaddedbackconfirmation: "પુષ્ટિ પર ઇન્વેન્ટરીમાં પાછા ઉમેરવામાં આવશે",
        Returnreason: "પરત કરવાનું કારણ",
        Optional: "વૈકલ્પિક",
        SelectReason: "કારણ પસંદ કરો",
        Additionalnotes: "વધારાની નોંધો",
        Describeofcustomerexplanation: "પરત કરેલી આઇટમની સ્થિતિ, કોઈપણ દેખીતું નુકસાન, ગ્રાહકની સમજૂતીનું વર્ણન કરો...",
        Requiredmustfilledcontinue: "ચાલુ રાખવા માટે જરૂરી ફીલ્ડ્સ ભરવા આવશ્યક છે",
        Reviewdetailsbeforeconfirming: "પુષ્ટિ કરતા પહેલા વિગતોની સમીક્ષા કરો",
        Replacementproductwilldeductedinventoryconfirmation: "બદલી ઉત્પાદન પુષ્ટિ પર તમારી ઇન્વેન્ટરીમાંથી બાદ કરવામાં આવશે.",
        Choosereplacementproduct: "બદલી ઉત્પાદન પસંદ કરો",
        Willdeductedfrominventoryconfirm: "પુષ્ટિ પર ઇન્વેન્ટરીમાંથી બાદ કરવામાં આવશે",
        Thesewillattachedothereturnrecord: "આ છબીઓ પરત રેકોર્ડ સાથે જોડવામાં આવશે",
        Replacementitem: "બદલી આઇટમ",
        Addanotherproduct: "બીજું ઉત્પાદન ઉમેરો",
        Replacementproductwillbe: "બદલી ઉત્પાદન",
        deducted: "બાદ",
        fromyourinventoryconfirmation: "પુષ્ટિ પર તમારી ઇન્વેન્ટરીમાંથી કરવામાં આવશે.",
        productadjustedusingprice: "પરત કરેલ ઉત્પાદન પુન: સ્ટોક કરવામાં આવશે અને મૂળ વેચાણ કિંમતનો ઉપયોગ કરીને નફો એડજસ્ટ કરવામાં આવશે.",
        Willloggedreturnedonlynotrestocked: "ફક્ત પરત કરેલ તરીકે નોંધવામાં આવશે — પુન: સ્ટોક કરવામાં આવશે નહીં",
        Returnonly: "ફક્ત પરત",
        Imagesofreturnedproduct: "પરત કરેલ ઉત્પાદનની છબીઓ",
        Returnedproductwill: "પરત કરેલ ઉત્પાદન",
        not: "નહીં",
        berestockedloggedreturnedonly: "પુન: સ્ટોક કરવામાં આવશે — ફક્ત પરત કરેલ તરીકે નોંધવામાં આવશે.",
        AddImage: "છબી ઉમેરો",
        STOCKIN: "સ્ટોક-ઇન",
        LOGONLY: "ફક્ત લોગ",
        ContinuetoReview: "સમીક્ષા કરવા માટે આગળ વધો →",
        Confirmreplacement: "બદલીની પુષ્ટિ કરો",
        Confirmreturn: "પરત કરવાની પુષ્ટિ કરો",
        Filldetailsbelowproceed: "આગળ વધવા માટે નીચેની વિગતો ભરો",
        Review: "સમીક્ષા",
        editdetails: "વિગતો સંપાદિત કરો",
        Configurereturndetails: "રીટર્ન વિગતો કોન્ફિગર કરો",
        Configurereplacementdetails: "બદલી વિગતો કોન્ફિગર કરો",
        SelectSource: "સ્ત્રોત પસંદ કરો",
        Returning: "પરત કરી રહ્યા છીએ",
        Replacement: "બદલી",
        WalkCustomer: "વોક-ઇન ગ્રાહક",
        RETURNEDPRODUCT: "પરત કરેલ પ્રોડક્ટ",
        REPLACEMENTPRODUCT: "બદલી પ્રોડક્ટ",
        STOCKOUT: "સ્ટોક-આઉટ",
        Netinventoryimpact: "ચોખ્ખી ઇન્વેન્ટરી અસર",
        Replacementitemcost: "બદલી આઇટમની કિંમત",
        Returneditemrestockvalue: "પરત કરેલી આઇટમની રિસ્ટોક કિંમત",
        PROFITINVENTORYSUMMARY: "નફો અને ઇન્વેન્ટરી સારાંશ",
        Inventoryaction: "ઇન્વેન્ટરી એક્શન",
        Valuededucted: "બાદ કરેલ કિંમત",
        Profitadjustment: "નફાનું એડજસ્ટમેન્ટ",
        stockedout: " સ્ટોક આઉટ થયો",
        restocked: " રિસ્ટોક થયું",
        Noaction: "કોઈ એક્શન નથી",
        Valuebeingreturned: "પરત કરવામાં આવતી કિંમત",
        Willberestocked: "રિસ્ટોક કરવામાં આવશે",
        Willbe: "થશે",
        logged: "નોંધવામાં",
        ON: "ચાલુ",
        OFF: "બંધ",
        Linked: "લિંક્ડ",
        Pleaseselectreturnedproduct: "કૃપા કરીને રિટર્ન કરેલ ઉત્પાદન પસંદ કરો",
        Quantityrequired: "જથ્થો જરૂરી છે",
        Buyingpricerequired: "ખરીદી કિંમત જરૂરી છે",
        Pleaseaddleastreplacementproduct: "કૃપા કરીને ઓછામાં ઓછું એક રિપ્લેસમેન્ટ ઉત્પાદન ઉમેરો",
        Pleaseconfigurereturnedproductdetails: "કૃપા કરીને રિટર્ન કરેલ ઉત્પાદનની વિગતો કોન્ફિગર કરો",
        Pleaseselectcustomer: "કૃપા કરીને ગ્રાહક પસંદ કરો",
        Returndateisrequired: "રિટર્ન તારીખ જરૂરી છે",
        Pleasefillallrequiredfields: "કૃપા કરીને તમામ જરૂરી ક્ષેત્રો ભરો",
        Wildeductedfrominventory: "ઇન્વેન્ટરીમાંથી કાપવામાં આવશે",
        Currentprice: "વર્તમાન કિંમત",
        Defectivedamaged: "ખામીયુક્ત / નુકસાન થયેલ",
        Wrongitemreceived: "ખોટી વસ્તુ મળી",
        Customerchangedmind: "ગ્રાહકે મન બદલ્યું",
        Sizefitissue: "સાઇઝ / ફીટ સમસ્યા",
        Notasdescribed: "વર્ણન મુજબ નથી",
        Other: "અન્ય",
        Originalsaleprice: "મૂળ વેચાણ કિંમત (નફા સમાયોજન)",
        Addedbackinventory: "ઇન્વેન્ટરીમાં ફરીથી ઉમેર્યું",
        Notaddedinventory: "ઇન્વેન્ટરીમાં ઉમેર્યું નથી",
        replacedwith: "સાથે બદલી",
        deductedfrominventory: "ઇન્વેન્ટરીમાંથી કાપવામાં આવ્યું",
        RETURNWITHSTOCKIN: "રિટર્ન · સ્ટોક-ઇન સાથે",
        RETURNNOSTOCKIN: "રિટર્ન · સ્ટોક-ઇન વિના",
        MULTIPLEREPLACEMENTS: "બહુવિધ રિપ્લેસમેન્ટ",
        SINGLEREPLACEMENT: "સિંગલ રિપ્લેસમેન્ટ",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "રિટર્ન્ડ · સ્ટોક ઇન",
        REPLACEMENTSTOCKOUT: "રિપ્લેસમેન્ટ · સ્ટોક આઉટ",
        Returnonlylogsthisentry: "ફક્ત પરત આ એન્ટ્રી લોગ કરે છે —",
        nostockwillbeaddedorremoved: "કોઈ સ્ટોક ઉમેરવામાં અથવા દૂર કરવામાં આવશે નહીં",
        frominventory: "ઇન્વેન્ટરીમાંથી.",
        Whentousethis: "આનો ઉપયોગ ક્યારે કરવો:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "વેચાણ માટે મોકલેલી વસ્તુઓ કે જે ક્ષતિગ્રસ્ત અથવા બિનઉપયોગી પરત આવી હોય તેને રેકોર્ડ કરવા માટે દિવસના અંતે 'પરત' નો ઉપયોગ કરો — એવી વસ્તુઓ કે જેને તમે ટ્રેક કરવા માંગો છો પરંતુ ઇન્વેન્ટરીમાં પાછી ઉમેરી શકતા નથી.",
        Youcanviewallpastreturnentriesin: "તમે ભૂતકાળની તમામ પરત એન્ટ્રીઓ અહીં જોઈ શકો છો",
        ReturnHistory: "પરત ઇતિહાસ",
        underthe: "નીચે",
        Others: "અન્ય",
        tab: "ટેબ.",
        Negativestocktransactiondisabled: "નકારાત્મક સ્ટોક વ્યવહારો અક્ષમ છે."
    },
    NewRLocal: {
        Originalsaleprice: "મૂળ વેચાણ કિંમત",
        Editinghistoryonlyinventorystaysunchanged: "ફક્ત ઇતિહાસ સંપાદિત કરી રહ્યા છીએ — ઇન્વેન્ટરી યથાવત રહે છે.",
        Changeshereupdatethisdetailsquantitiesaffected: "અહીં ફેરફારો ફક્ત આ રેકોર્ડની વિગતો (કારણ, તારીખ, નોંધો) અપડેટ કરે છે. તમારા વાસ્તવિક સ્ટોક જથ્થા, બિન સ્થાનો અને ઉત્પાદન ડેટાને અસર થતી નથી.",
        Needtofixinventorylevelsinstead: "તેના બદલે ઇન્વેન્ટરી લેવલ ઠીક કરવાની જરૂર છે?",
        AdjustStock: "સ્ટોક એડજસ્ટ કરો",
        Refund: "રીફંડ",
        ImportantNote: "મહત્વપૂર્ણ નોંધ",
        Pleasereviewbeforecontinuing: "ચાલુ રાખતા પહેલા કૃપા કરીને સમીક્ષા કરો",
        Onceshippedreceivedanyupdatesmadeorder: "એકવાર ઓર્ડર મોકલવામાં આવે અથવા પ્રાપ્ત થાય, ઓર્ડરમાં કરવામાં આવેલ કોઈપણ અપડેટ ટ્રાન્ઝેક્શન ઇતિહાસમાં પ્રતિબિંબિત થશે નહીં.",
        Thisundone: "આ ઓર્ડરને કાયમી ધોરણે દૂર કરશે. આ ક્રિયા પૂર્વવત્ કરી શકાતી નથી.",
        Inventorywilladjustedautomatically: "ઇન્વેન્ટરી આપમેળે એડજસ્ટ થશે નહીં",
        Deletingthisreversevedshippedyouwillneed: "આને કાઢી નાખવાથી કોઈપણ સ્ટોક ફેરફારો ઉલટાવતા નથી. જો વસ્તુઓ પહેલેથી જ પ્રાપ્ત/મોકલવામાં આવી હોય, તો તમારે જરૂર પડશે",
        reflectthecorrectstocklevels: "સાચો સ્ટોક લેવલ બતાવવા માટે.",
        manuallyadjustyourinventory: "તમારી ઇન્વેન્ટરી મેન્યુઅલી એડજસ્ટ કરો",
        Addremovestockforitemsthatwereshipped: "મોકલવામાં આવેલી વસ્તુઓ માટે સ્ટોક ઉમેરો અથવા દૂર કરો",
        Addremovestockforitemsthatwerereceived: "પ્રાપ્ત થયેલ વસ્તુઓ માટે સ્ટોક ઉમેરો અથવા દૂર કરો",
        Updatecostrecordspaymentwaalreadymade: "જો ચુકવણી પહેલેથી જ કરવામાં આવી હોય તો ખર્ચ રેકોર્ડ અપડેટ કરો",
        Reconcilerecordsandoutstandingpayments: "રેકોર્ડ્સ અને બાકી ચુકવણીઓનું સમાધાન કરો"
    },
    ReceivablesLocal: {
        Receivables: "પ્રાપ્ય",
        Manageandtrackcustomerduebalances: "ગ્રાહકોના બાકી રકમનું સંચાલન અને ટ્રેકિંગ કરો",
        Viewcustomerduebalancereport: "ગ્રાહક બાકી રકમ અહેવાલ જુઓ",
        Viewsupplierduebalancereport: "સપ્લાયર બાકી રકમ અહેવાલ જુઓ",
        DueBalance: "બાકી રકમ",
        Unpaid: "બાકી",
        PartiallyPaid: "આંશિક ચુકવેલ",
        Paid: "ચુકવેલ",
        HighestBalance: "સર્વોચ્ચ બાકી",
        LowestBalance: "ન્યૂનતમ બાકી",
        Filldetailsrecordpayment: "ચુકવણી નોંધવા માટે વિગતો ભરો",
        NewPaymentEntry: "નવી ચુકવણી એન્ટ્રી",
        EditPaymentEntry: "ચુકવણી એન્ટ્રી સંપાદિત કરો",
        Nosuppliersfound: "કોઈ સપ્લાયર મળ્યા નથી",
        Nocustomersfound: "કોઈ ગ્રાહક મળ્યા નથી",
        LowtoHigh: "નીચેથી ઉપર",
        HightoLow: "ઉપરથી નીચે",
        AttachmentUploadedSc: "એટેચમેન્ટ સફળતાપૂર્વક અપલોડ થયું",
        AttachmentUploadedF: "એટેચમેન્ટ અપલોડ કરવામાં નિષ્ફળ",
        Pay: "ચુકવણી કરો",
        NoBillsFound: "કોઈ બિલ મળ્યા નથી",
        Thiscustomerhasunpaidbills: "આ ગ્રાહક પાસે કોઈ બાકી બિલ નથી.",
        TotalDue: "કુલ બાકી",
        BillsFound: "બિલ મળ્યા",
        DeselectAll: "બધું અનસિલેક્ટ કરો",
        SelectAll: "બધું પસંદ કરો",
        ShowDetails: "વિગતો બતાવો"
    },
    AssetsNewLocal: {
        AssignedAssets: "સોંપેલ સંપત્તિઓ",
        Noassetsassignedstaffmember: "આ સ્ટાફ મેમ્બરને કોઈ સંપત્તિ સોંપેલ નથી.",
        Assignassetstaff: "સ્ટાફને સંપત્તિ સોંપો",
        Returnassetfromstaff: "સ્ટાફ પાસેથી આ સંપત્તિ પરત કરો",
        AssignmentDetails: "સોંપણીની વિગતો",
        Serial: "સીરીયલ",
        ViewAssets: "બધી સંપત્તિઓ જુઓ",
        ViewByStaff: "સ્ટાફ પ્રમાણે જુઓ",
        AssignedHistory: "સોંપણી ઇતિહાસ",
        Returned: "પરત કરેલ",
        Returnedon: "પરત કરેલ તારીખે",
        ReturnedBy: "પરત કરનાર",
        AssignedTo: "સોંપેલ",
        NoHistoryRecords: "કોઈ ઇતિહાસ રેકોર્ડ નથી",
        Selectstaffmemberviewtheirassets: "તેમની સંપત્તિઓ જોવા માટે સ્ટાફ મેમ્બર પસંદ કરો",
        searchPlaceholder: "નામ અથવા સીરીયલ નંબર દ્વારા સંપત્તિ શોધો..."
    },
    InventoryCountLocale: {
        InventoryCount: "ઇન્વેન્ટરી કાઉન્ટ",
        Viewinventorycountreport: "ઇન્વેન્ટરી કાઉન્ટ અહેવાલ જુઓ",
        ItemsCount: "આઇટમ્સની સંખ્યા",
        All: "બધા",
        InProgress: "પ્રગતિમાં",
        Submitted: "સબમિટ કરેલ",
        awaitingreview: "સમીક્ષાની રાહમાં",
        EditInventoryCount: "ઇન્વેન્ટરી કાઉન્ટ સંપાદિત કરો",
        NewInventoryCount: "નવી ઇન્વેન્ટરી કાઉન્ટ",
        Modifyinventorycountsheetdetails: "ઇન્વેન્ટરી કાઉન્ટ શીટની વિગતો સંપાદિત કરો",
        Startanewinventorycountsheet: "નવી ઇન્વેન્ટરી કાઉન્ટ શીટ શરૂ કરો",
        GeneralInformation: "સામાન્ય માહિતી",
        Title: "શીર્ષક",
        SaveChanges: "ફેરફારો સાચવો",
        Selectproductsforthisinventorycountsheet: "આ શીટ માટે પ્રોડક્ટ્સ પસંદ કરો",
        InventoryCountDetails: "ઇન્વેન્ટરી કાઉન્ટ વિગતો",
        Inventorycountsheetdetails: "ઇન્વેન્ટરી કાઉન્ટ શીટ વિગતો",
        Viewingdetailsforcountsheet: "કાઉન્ટ શીટની વિગતો જોઈ રહ્યા છીએ",
        Started: "શરૂ કરેલ",
        TaskSheets: "ટાસ્ક શીટ્સ",
        Allitems: "બધી આઇટમ્સ",
        NotStarted: "શરૂ નથી",
        Completed: "પૂર્ણ",
        Results: "પરિણામો",
        ViewResults: "પરિણામો જુઓ",
        DeleteInventoryCount: "ઇન્વેન્ટરી કાઉન્ટ કાઢી નાખો",
        Viewingtransactionandadjustments: "વ્યવહાર અને સ્ટોક એડજસ્ટમેન્ટ જોઈ રહ્યા છીએ",
        Productsadjusted: "સમાયોજિત પ્રોડક્ટ્સ",
        Assignee: "સોંપેલ",
        Tasksheetdetails: "ટાસ્ક શીટ વિગતો",
        Draft: "ડ્રાફ્ટ",
        VariantQuantities: "વેરિઅન્ટ જથ્થા",
        AssignedProducts: "સોંપેલ પ્રોડક્ટ્સ",
        ReturnAsset: "સંપત્તિ પરત કરો",
        EditTasksheet: "ટાસ્ક શીટ સંપાદિત કરો",
        NewTasksheet: "નવી ટાસ્ક શીટ",
        Updatetasksheetdetails: "ટાસ્ક શીટ વિગતો અપડેટ કરો",
        Starttasksheetforthisinventorycount: "આ ઇન્વેન્ટરી કાઉન્ટ માટે નવી ટાસ્ક શીટ શરૂ કરો",
        TaskSheetInformation: "ટાસ્ક શીટ માહિતી",
        SheetTitle: "શીટ શીર્ષક",
        Entersheettitle: "શીટ શીર્ષક દાખલ કરો",
        SubmissionResult: "સબમિશન પરિણામ",
        ReviewChanges: "ફેરફારોની સમીક્ષા કરો",
        Viewingsubmissionresultsforthisinventorycount: "આ ઇન્વેન્ટરી કાઉન્ટ માટે સબમિશન પરિણામો જુઓ",
        Reviewyourinventorycountbeforesubmitting: "સબમિટ કરતા પહેલા તમારી ઇન્વેન્ટરી કાઉન્ટની સમીક્ષા કરો"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "કાઉન્ટ્સ લોડ કરવામાં નિષ્ફળ",
        NoInventoryCounts: "કોઈ ઇન્વેન્ટરી કાઉન્ટ નથી",
        NoMatches: "કોઈ મેચ નથી",
        Therearenoinventorycountswiththestatus: "આ સ્થિતિ સાથે કોઈ ઇન્વેન્ટરી કાઉન્ટ નથી",
        Noinventorycountsfoundyoursearchterm: "તમારા સર્ચ ટર્મ સાથે કોઈ ઇન્વેન્ટરી કાઉન્ટ મળ્યા નથી.",
        Thereareinventorycountsrecordedyetforthisbusiness: "આ વ્યવસાય માટે હજુ સુધી કોઈ ઇન્વેન્ટરી કાઉન્ટ રેકોર્ડ કરવામાં આવ્યા નથી."
    },
    StockinModalP: {
        StockInNow: "હવે સ્ટોક ઉમેરો",
        Settheopeningquantityforthisproductrightnow: "આ પ્રોડક્ટ માટે હવે શરૂઆતી જથ્થો સેટ કરો.",
        Addinitialstock: "શરૂઆતી સ્ટોક ઉમેરવો છે?",
        dothislater: "હું આ પછી કરીશ",
        Productadded: "પ્રોડક્ટ ઉમેરાઈ!",
        isready: "તૈયાર છે.",
        SeeHowItWorks: "જુઓ કેવી રીતે કામ કરે છે",
        NoSalesOrdersFound: "કોઈ વેચાણ ઓર્ડર મળ્યા નથી",
        NoPurchaseOrdersFound: "કોઈ ખરીદી ઓર્ડર મળ્યા નથી",
        Startcreatingoutgoinginventoryrevenue: "વેચાણ ઓર્ડર બનાવવાનું શરૂ કરો જેથી તમારા આઉટગોઇંગ સ્ટોક અને આવકને ટ્રેક કરી શકો.",
        Trackrestockssupplierplace: "તમારા સ્ટોક રીસ્ટોક અને સપ્લાયર ઓર્ડરને એક જ જગ્યાએ ટ્રેક કરો.",
        CreateSalesOrder: "વેચાણ ઓર્ડર બનાવો",
        CreatePurchaseOrder: "ખરીદી ઓર્ડર બનાવો",
    }
    ,
    dialy_report: "દૈનિક મૂવમેન્ટ રિપોર્ટ",
    Quotation: "ક્વોટ",
    Quote: "ક્વોટ",
    Assignee: "સોંપેલ",
    dayStart: "દિવસની શરૂઆત",

    ShowTotalAmount: "કુલ રકમ દર્શાવો",


    tutorial: {
        watchTitle: 'સ્ટેપ-બાય-સ્ટેપ ટ્યુટોરિયલ્સ જુઓ',
        watchDesc: 'અમારી YouTube ચેનલ પર SimplyStock શીખો',
        modalTitle: 'SimplyStock સાથે આગળ રહો',
        modalDesc: 'નવા ટ્યુટોરિયલ્સ ડ્રોપ થતાં જ તેમને મેળવવા માટે સબ્સ્ક્રાઇબ કરો',
        feature1Title: 'નવી સુવિધા વૉકથ્રૂ',
        feature1Sub: 'દરેક નવા અપડેટને ટૂંકી વિડિઓ સાથે સમજાવવામાં આવે છે — જેથી તમે નવું શું છે તે ક્યારેય ચૂકશો નહીં',
        feature2Title: 'ઝડપી કેવી રીતે કરવું તે વિડિઓઝ',
        feature2Sub: '5 મિનિટથી ઓછા સમયમાં સ્ટોક, ઇન્વૉઇસેસ, સ્ટાફ એક્સેસ અને વધુ સેટ કરો',
        feature3Title: 'ત્વરિત સૂચનાઓ',
        feature3Sub: 'નવું ટ્યુટોરીયલ લાઇવ થાય તે ક્ષણે સૂચિત કરો — તમારી પોતાની ગતિએ શીખો',
        feature4Title: '100% મફત, હંમેશા',
        feature4Sub: 'બધા ટ્યુટોરિયલ્સ કાયમ માટે મફત છે — કોઈ લૉગિન અથવા સબ્સ્ક્રિપ્શનની જરૂર નથી',
        subscribeBtn: 'SimplyStock પર સબ્સ્ક્રાઇબ કરો',
        maybeLater: 'કદાચ પછીથી'
    }
    ,
    dailyCashReport: {
        "title": "દૈનિક કેશ રિપોર્ટ",
        "subtitle": "કોણે શું ચૂકવ્યું, કઈ તારીખે, અને શું બાકી છે — વેચાણ વિગતોમાંથી જૂથબદ્ધ.",
        "totalSales": "કુલ વેચાણ",
        "cashReceived": "કુલ પ્રાપ્ત",
        "outstanding": "બાકી",
        "collectionRate": "કલેક્શન રેટ",
        "grandTotalAllDates": "કુલ સરવાળો (તમામ તારીખો)",
        "totalLabel": "કુલ",
        "loading": "લોડ થઈ રહ્યું છે...",
        "noData": "પસંદ કરેલ તારીખ શ્રેણી માટે કોઈ ડેટા મળ્યો નથી.",
        "loadingMore": "વધુ લોડ થઈ રહ્યું છે..."
    },
    dailyCashReportColumns: {
        "date": "તારીખ",
        "customer": "ગ્રાહક",
        "productsSold": "વેચાયેલ પ્રોડક્ટ્સ",
        "products": "પ્રોડક્ટ્સ",
        "salesAmount": "વેચાણ રકમ",
        "sales": "વેચાણ",
        "received": "કુલ પ્રાપ્ત",
        "receivedShort": "પ્રાપ્ત",
        "debited": "ખાતાવહીમાં ડેબિટ",
        "due": "બાકી",
        "paymentModes": "ચુકવણી મોડ",
        "mode": "મોડ"
    }
}


export default gu
